import { yupResolver } from '@hookform/resolvers/yup';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Modal,
  Popover,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import CheckGreen from 'assets/images/check-alert-green.svg';
import CheckRed from 'assets/images/check-alert-red.svg';
import CloseCircleIcon from 'assets/images/close-circle.svg';
import DollarIcon from 'assets/images/dollar-sign-green.svg';
// import PaidIcon from 'assets/images/status-paid.svg';
import UploadAlert from 'assets/images/upload-alert.svg';
import CustomButton from 'components/CustomButton/customButton';
import CustomInput from 'components/CustomInput/customInput';
import CustomSelect from 'components/CustomSelect/customSelect';
import DatePicker from 'components/DatePicker';
import TimesheetBox from 'components/TimesheetBox/timesheetBox';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import _ from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import FileViewer from 'react-file-viewer';
import { Controller, useForm } from 'react-hook-form';
import LoadingOverlay from 'react-loading-overlay';
import {
  addNewData,
  getAllListData,
  updateData,
} from 'services/CommonServices';
import { useAppSelector } from 'store/hooks';
import { addNotesForm } from 'types';
import { roundOfData } from 'utils/Config';
import { MASTER_ENDPOINT, TIMESHEET } from 'utils/Constant';
import { fetchAuthenticatedFileBlob } from 'utils/fetchAuthenticatedFileBlob';
import { addNotesSchema } from 'utils/ValidatorSchema';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const style = {
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  left: '50%',
  maxHeight: '90vh',
  overflowY: 'auto',
  p: 4,
  position: 'absolute' as const,
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: 654,
};
const editstyle = {
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  left: '50%',
  maxHeight: '90vh',
  overflowY: 'auto',
  p: 4,
  position: 'absolute' as const,
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
};
const style1 = {
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  left: '50%',
  maxHeight: '90vh',
  overflowY: 'auto',
  p: 4,
  position: 'absolute' as const,
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: 486,
};
const style2 = {
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  left: '50%',
  maxHeight: '90vh',
  overflowY: 'auto',
  p: 4,
  position: 'absolute' as const,
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: 614,
};
const styleView = {
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  left: '50%',
  maxHeight: '90vh',
  overflowY: 'auto',
  p: 4,
  position: 'absolute' as const,
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: 614,
};

const assignmentDatesStyles = {
  assignmentDate: {
    color: '#979598',
    fontFamily: 'Red Hat Display Regular',
    fontSize: 11,
    lineHeight: 1.35,
  },
  wrapper: { mt: 0.25 },
};

const AssignmentDates: React.FC<{ projectConsultant?: any }> = ({
  projectConsultant,
}) => {
  if (!projectConsultant) return null;
  const { startDate, endDate, extendedEndDate } = projectConsultant;
  if (!startDate && !endDate && !extendedEndDate) return null;
  const fmt = (date: any) => (date ? moment(date).format('MMM DD, YYYY') : '—');
  return (
    <Box sx={assignmentDatesStyles.wrapper}>
      <Typography component="div" sx={assignmentDatesStyles.assignmentDate}>
        Start: {fmt(startDate)}
      </Typography>
      <Typography component="div" sx={assignmentDatesStyles.assignmentDate}>
        End: {fmt(endDate)}
      </Typography>
      {extendedEndDate && (
        <Typography component="div" sx={assignmentDatesStyles.assignmentDate}>
          Ext. End: {fmt(extendedEndDate)}
        </Typography>
      )}
    </Box>
  );
};

export const TimesheetComponent: React.FC<any> = ({
  consultantId,
  showPaid,
  showApproved,
  isAdminScreen,
  showHours,
}) => {
  const [rows, setRows] = useState<any>([]);
  const [splitHoursState, setSplitHoursState] = useState<
    Record<string, { a: string; b: string }>
  >({});
  const [splitAdjust, setSplitAdjust] = React.useState<{
    a: string;
    b: string;
  }>({ a: '0.00', b: '0.00' });
  const [hoursPopover, setHoursPopover] = useState<{
    anchor: HTMLElement | null;
    ctx: any;
    draft: { a: string; b: string; selected: 'a' | 'b' };
  }>({
    anchor: null,
    ctx: null,
    draft: { a: '0.00', b: '0.00', selected: 'a' },
  });
  const [expand, setExpand] = useState<any>();
  const [loading2, setLoading2] = useState(false);
  const [selectedYear, setSelectedYear] = useState<number>(
    parseInt(moment().format('YYYY')),
  ); // Fix type
  const [open1, setOpen1] = useState(false);
  const [selectedTimesheetsIndex, setSelectedTimesheetsIndex] = useState(-1);
  const [selectedTimesheetPeriodIndex, setSelectedTimesheetPeriodIndex] =
    useState(-1);
  const [fileUploadLoading, setFileUploadLoading] = useState<any>(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState<any>(-1);
  const [timeSheetViewSelected, setTimeSheetViewSelected] = useState<any>({});
  const [notesLoading, setNotesLoading] = useState<any>(false);
  const [openViewDocument, setOpenViewDocument] = useState<any>(false);
  const [viewFileBlobUrl, setViewFileBlobUrl] = useState<string | null>(null);
  const [viewFileLoading, setViewFileLoading] = useState(false);
  const viewFileBlobUrlRef = useRef<string | null>(null);
  const viewFileFetchGenRef = useRef(0);

  const revokeViewFileBlobUrl = () => {
    if (viewFileBlobUrlRef.current) {
      URL.revokeObjectURL(viewFileBlobUrlRef.current);
      viewFileBlobUrlRef.current = null;
    }
    setViewFileBlobUrl(null);
  };
  const [openAddWeekNotes, setOpenAddWeekNotes] = useState(false);
  const [currentExpandId, setCurrentExpandId] = useState('');
  const [open, setOpen] = useState(false);
  const [payPeriods, setPayPeriods] = useState([]);
  const [payPeriodId, setPayPeriodId] = useState('');
  const [openGenerateTimesheet, setOpenGenerateTimesheet] = useState(false);
  const [editopen, setEditOpen] = React.useState<any>({
    data: {},
    fullVisible: false,
    id: '',
    open: false,
    periodFrom: '',
    periodId: '',
    periodTo: '',
  });
  const handleEditOpen = (
    item: any,
    fullVisible: boolean,
    id: any,
    periodId: any,
    timesheetPeriod?: any,
  ) => {
    setEditOpen({
      data: item,
      fullVisible: fullVisible,
      id: id,
      open: true,
      periodFrom: timesheetPeriod?.periodFrom ?? '',
      periodId: periodId,
      periodTo: timesheetPeriod?.periodTo ?? '',
    });
    const prior = item?.timesheetYearSplits?.adjustedPriorYearHours ?? 0;
    const current = item?.timesheetYearSplits?.adjustedCurrentYearHours ?? 0;
    setSplitAdjust({
      a: Number(prior).toFixed(2),
      b: Number(current).toFixed(2),
    });
  };
  const handleEditClose = () => {
    setEditOpen({
      data: {},
      fullVisible: false,
      id: '',
      open: false,
      periodId: '',
    });
  };
  const { userInfo }: any = useAppSelector((store: any) => store.userLogin);
  const handleOpenGenerateTimesheet = () => {
    setOpenGenerateTimesheet(true);
  };
  const handleCloseGenerateTimesheet = () => {
    setOpenGenerateTimesheet(false);
    // setSelectedRowIndex(-1);
    // setSelectedTimesheetPeriodIndex(-1);
  };
  const [timeSheetProjectConsultantId, setTimeSheetProjectConsultantId] =
    useState('');
  const submitAdjustHour = () => {
    if (!editopen.fullVisible) {
      const isSplitWeek = isYearSplitPeriod(
        editopen.periodFrom,
        editopen.periodTo,
      );
      const adjustedA = parseFloat(splitAdjust.a) || 0;
      const adjustedB = parseFloat(splitAdjust.b) || 0;
      const bodyObject = {
        timesheets: [
          {
            adjustedBy: userInfo?.id,
            adjustmentHours: isSplitWeek
              ? adjustedA + adjustedB
              : editopen.data.adjustmentHours,
            hourAdjustNotes: editopen.data.hourAdjustNotes,
            id: editopen.data.id,
            ...(isSplitWeek && {
              adjustedCurrentYearHours: adjustedB,
              adjustedPriorYearHours: adjustedA,
            }),
          },
        ],
      };
      updateData(
        String(editopen.id) + '/' + String(editopen.periodId),
        bodyObject,
        TIMESHEET.TimeSheetsHours,
        true,
      )
        .then(() => {
          getTimesheetList(currentExpandId, expand);
          handleEditClose();
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  };

  const viewFormatSupportedArray = [
    'jpeg',
    'jpg',
    'gif',
    'png',
    'pdf',
    'csv',
    'xslx',
    'docx',
    'xls',
  ];

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    getPayPeriods(selectedYear);
  }, [selectedYear]);
  const [projectsList, setProjectsList] = React.useState([]);

  const getData = useCallback(() => {
    setLoader(true);
    getAllListData(
      MASTER_ENDPOINT.ProjectsConsultant + '?userId=' + consultantId,
    )
      .then((resp: any) => {
        setProjectsList(resp.data);
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
      });
  }, [consultantId]);
  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    return () => {
      if (viewFileBlobUrlRef.current) {
        URL.revokeObjectURL(viewFileBlobUrlRef.current);
        viewFileBlobUrlRef.current = null;
      }
    };
  }, []);

  const getPayPeriods = (year: number) => {
    getAllListData(MASTER_ENDPOINT.Payperiods)
      .then((resp: any) => {
        const transformedData = resp.data
          .filter((item: any) => item.year === year)
          .flatMap((item: any) => item.payPeriodQuarters)
          .flatMap((item: any) => item.payPeriods)
          .sort((a: any, b: any) => {
            return new Date(a.endDate) > new Date(b.endDate); //Check with Sudhi on sorting
          });
        setPayPeriods(transformedData);
      })
      .catch(() => {});
  };
  const {
    handleSubmit: handleAddNotesSubmit,
    control,
    formState,
    reset,
    setValue,
  } = useForm<addNotesForm>({
    defaultValues: {
      note: '',
    },
    reValidateMode: 'onChange',
    resolver: yupResolver(addNotesSchema),
  });

  const handleSaveGenerateTimesheet = () => {
    const bodyObject = {
      payPeriodId: payPeriodId,
      projectConsultantId: timeSheetProjectConsultantId,
      userId: consultantId,
    };
    setLoader(true);
    addNewData(bodyObject, MASTER_ENDPOINT.TimesheetCreate, {}, true)
      .then(() => {
        getTimesheetList(currentExpandId, expand, [], true);
        handleCloseGenerateTimesheet();
        setLoader(false);
        setPayPeriodId('');
        setTimeSheetProjectConsultantId('');
        getTimesheets();
      })
      .catch((error: any) => {
        console.log(error);
        setLoader(false);
      });
  };
  const toggleAcordion = (index, basePeriodId) => {
    setExpand(index === expand ? -1 : index);
    index === expand ? '' : getTimesheetList(basePeriodId, index);
    setCurrentExpandId(index === expand ? '' : basePeriodId);
  };

  const getTimesheetList = (
    basePeriodId: any,
    index: any,
    rowArr?: any,
    loaderShow?: boolean,
  ) => {
    !loaderShow && setLoading2(true);
    getAllListData(
      `${TIMESHEET.TimeSheets}/list?id=${String(
        basePeriodId,
      )}&payPeriodYear=${selectedYear}`,
    )
      .then((response: any) => {
        if (response?.data) {
          if (rowArr && rowArr.length) {
            const sortedArr = _.sortBy(
              response.data,
              function (e) {
                return new Date(e?.periodFrom);
              },
              ['asc'],
            );
            rowArr[index].timesheetPeriods = sortedArr;
            setRows([...rowArr]);
          } else {
            const sortedArr = _.sortBy(
              response.data,
              function (e) {
                return new Date(e?.periodFrom);
              },
              ['asc'],
            );
            rows[index].timesheetPeriods = sortedArr;
            setRows([...rows]);
          }
        }
        !loaderShow && setLoading2(false);
        setLoader(false);
      })
      .catch(() => {
        !loaderShow && setLoading2(false);
        setLoader(false);
      });
  };

  const handleOpen = (index, periodIndex) => {
    setSelectedRowIndex(index);
    setSelectedTimesheetPeriodIndex(periodIndex);
    setOpen(true);
  };
  const handleClose1 = () => {
    delete rows[selectedRowIndex]?.files;
    setSelectedTimesheetsIndex(-1);
    setSelectedTimesheetPeriodIndex(-1);
    setSelectedRowIndex(-1);
    setOpen1(false);
  };
  const handleClose = () => {
    setSelectedRowIndex(-1);
    setSelectedTimesheetPeriodIndex(-1);
    setOpen(false);
  };
  const handleCloseAddWeekNotes = () => {
    setSelectedRowIndex(-1);
    setSelectedTimesheetPeriodIndex(-1);
    setOpenAddWeekNotes(false);
  };
  const handleOpen1 = (timesheetsIndex, timesheetPeriodIndex, index) => {
    setSelectedTimesheetsIndex(timesheetsIndex);
    setSelectedTimesheetPeriodIndex(timesheetPeriodIndex);
    setSelectedRowIndex(index);
    setOpen1(true);
  };
  const handleOpenViewDocumentModel = (fileInfoObject: any) => {
    const gen = ++viewFileFetchGenRef.current;
    revokeViewFileBlobUrl();
    setTimeSheetViewSelected(fileInfoObject);
    setOpenViewDocument(true);
    setViewFileLoading(true);
    fetchAuthenticatedFileBlob(String(fileInfoObject.id))
      .then((blob) => {
        if (gen !== viewFileFetchGenRef.current) {
          return;
        }
        const url = URL.createObjectURL(blob);
        viewFileBlobUrlRef.current = url;
        setViewFileBlobUrl(url);
      })
      .catch(() => {
        if (gen !== viewFileFetchGenRef.current) {
          return;
        }
      })
      .finally(() => {
        if (gen === viewFileFetchGenRef.current) {
          setViewFileLoading(false);
        }
      });
  };
  const handleRemoveOutSick = (
    outSickIndex,
    timesheetPeriodIndex,
    timesheetPeriod,
    index,
  ) => {
    // Remove the entry from the array
    timesheetPeriod[timesheetPeriodIndex].outSicks.splice(outSickIndex, 1);
    rows[index].timesheetPeriods = timesheetPeriod;
    setRows([...rows]);
  };
  const handleOpenAddWeekNotes = (timesheetPeriodIndex, index) => {
    if (
      !rows[index].timesheetPeriods[timesheetPeriodIndex]?.notes ||
      rows[index].timesheetPeriods[timesheetPeriodIndex]?.notes.length === 0
    ) {
      rows[index].timesheetPeriods[timesheetPeriodIndex].notes = [
        {
          note: '',
          timesheetPeriodId:
            rows[index].timesheetPeriods[timesheetPeriodIndex].id,
          userId: rows[index].userId,
        },
      ];
    }
    setValue(
      'note',
      rows[index]?.timesheetPeriods[timesheetPeriodIndex]?.notes[0].note,
    );
    setSelectedRowIndex(index);
    setSelectedTimesheetPeriodIndex(timesheetPeriodIndex);
    setRows([...rows]);
    setOpenAddWeekNotes(true);
  };
  const checkPaymentPending = (row) => {
    let isPaymentPending = true;
    row.timesheetPeriods &&
      row.timesheetPeriods.map((data) => {
        if (data.timesheets && data.timesheets.length === 0) {
          return false;
        }
        isPaymentPending = data.timesheets?.find((o) => o?.paid === false);
        if (isPaymentPending != undefined) {
          return false;
        }
      });
    return isPaymentPending === undefined ? false : true;
  };
  const getTotalHours = (row) => {
    let totalHours = 0.0;
    row?.timesheetPeriods.map((data) => {
      data.timesheets.map((timesheet) => {
        // Only use adjustment hours when they are greater than 0
        if (
          timesheet.adjustmentHours &&
          Number(timesheet.adjustmentHours) > 0
        ) {
          totalHours = Number(totalHours) + Number(timesheet.adjustmentHours);
        } else {
          totalHours = Number(totalHours) + Number(timesheet.hours);
        }
      });
      data.outSicks.map((outSick) => {
        totalHours = Number(totalHours) + Number(outSick.hours);
      });
    });
    return Number(totalHours).toFixed(2);
  };
  const capitalizeText = (text) => {
    return text?.charAt(0).toUpperCase() + text?.slice(1);
  };
  const isYearSplitPeriod = (periodFrom: any, periodTo: any) => {
    if (!periodFrom || !periodTo) return false;
    return moment(periodFrom).year() !== moment(periodTo).year();
  };
  const getSplitHoursValues = (tpId: any, tId: any, timesheet: any) => {
    const key = `${String(tpId)}-${String(tId)}`;
    if (splitHoursState[key]) return splitHoursState[key];
    // Read backend-persisted split values on load/refresh so they survive a page reload
    const splits = timesheet?.timesheetYearSplits;
    if (
      splits?.priorYearHours !== undefined ||
      splits?.currentYearHours !== undefined
    ) {
      return {
        a: String(splits.priorYearHours ?? '0.00'),
        b: String(splits.currentYearHours ?? '0.00'),
      };
    }
    return { a: String(timesheet?.hours || '0.00'), b: '0.00' };
  };
  const sanitizeHoursInput = (value: string) => {
    const clean = value.replace(/[^\d.]/g, '');
    if (!clean.match(/^[0-9]*\.?[0-9]*$/)) return null;
    const parts = clean.split('.');
    if (parts[1] && parts[1].length > 2) return null;
    return clean;
  };
  const openHoursPopover = (
    e: React.MouseEvent<HTMLElement>,
    index: number,
    timesheetPeriodIndex: number,
    timesheetsIndex: number,
    timesheetPeriod: any,
    timesheet: any,
  ) => {
    const ranges = getYearSplitRanges(
      timesheetPeriod?.periodFrom,
      timesheetPeriod?.periodTo,
    );
    const current = getSplitHoursValues(
      timesheetPeriod?.id,
      timesheet?.id,
      timesheet,
    );
    setHoursPopover({
      anchor: e.currentTarget,
      ctx: {
        index,
        ranges,
        timesheet,
        timesheetPeriod,
        timesheetPeriodIndex,
        timesheetsIndex,
      },
      draft: {
        a: current.a,
        b: current.b,
        selected: 'a',
      },
    });
  };
  const closeHoursPopover = () => {
    setHoursPopover((prev) => ({ ...prev, anchor: null, ctx: null }));
  };
  const updateHoursDraft = (field: 'a' | 'b', value: string) => {
    const clean = sanitizeHoursInput(value);
    if (clean === null) return;
    setHoursPopover((prev) => ({
      ...prev,
      draft: { ...prev.draft, [field]: clean },
    }));
  };
  const updateHoursDraftSelected = (value: 'a' | 'b') => {
    setHoursPopover((prev) => ({
      ...prev,
      draft: { ...prev.draft, selected: value },
    }));
  };
  const applyHoursPopover = () => {
    const { ctx, draft } = hoursPopover;
    if (!ctx) return;
    const key = `${String(ctx.timesheetPeriod?.id)}-${String(
      ctx.timesheet?.id,
    )}`;
    const normalized = {
      a: draft.a || '0.00',
      b: draft.b || '0.00',
    };
    setSplitHoursState((prev) => ({ ...prev, [key]: normalized }));
    const total = (
      (parseFloat(normalized.a) || 0) + (parseFloat(normalized.b) || 0)
    ).toFixed(2);
    const rowsCopy = [...rows];
    rowsCopy[ctx.index].timesheetPeriods[ctx.timesheetPeriodIndex].timesheets[
      ctx.timesheetsIndex
    ].hours = total;
    rowsCopy[ctx.index].timesheetPeriods[ctx.timesheetPeriodIndex].timesheets[
      ctx.timesheetsIndex
    ].priorYearHours = parseFloat(normalized.a) || 0;
    rowsCopy[ctx.index].timesheetPeriods[ctx.timesheetPeriodIndex].timesheets[
      ctx.timesheetsIndex
    ].currentYearHours = parseFloat(normalized.b) || 0;
    setRows(rowsCopy);
    closeHoursPopover();
  };

  const getYearSplitRanges = (periodFrom: any, periodTo: any) => {
    const start = moment(periodFrom);
    const end = moment(periodTo);
    const firstEnd = moment(start).endOf('year').startOf('day');
    const secondStart = moment(end).startOf('year');
    const firstDays = firstEnd.diff(start, 'days') + 1;
    const secondDays = end.diff(secondStart, 'days') + 1;
    const formatRange = (from: moment.Moment, to: moment.Moment) =>
      from.month() === to.month()
        ? `${from.format('MMM')} ${from.format('DD')} - ${to.format(
            'DD',
          )}, ${to.format('YYYY')}`
        : `${from.format('MMM DD')} - ${to.format('MMM DD')}, ${to.format(
            'YYYY',
          )}`;
    const formatShort = (from: moment.Moment, to: moment.Moment) =>
      from.month() === to.month()
        ? `${from.format('MMM')} ${from.format('DD')} – ${to.format('DD')}`
        : `${from.format('MMM DD')} – ${to.format('MMM DD')}`;
    return {
      first: {
        days: firstDays,
        label: formatRange(start, firstEnd),
        shortLabel: formatShort(start, firstEnd),
        year: start.year(),
      },
      second: {
        days: secondDays,
        label: formatRange(secondStart, end),
        shortLabel: formatShort(secondStart, end),
        year: end.year(),
      },
    };
  };
  const getTotalHoursSingleRow = (timesheetPeriod: any) => {
    if (timesheetPeriod && timesheetPeriod.timesheets) {
      let totalHours = 0.0;
      timesheetPeriod.timesheets.map((timesheet) => {
        // Only use adjustment hours when they are greater than 0
        if (
          timesheet.adjustmentHours &&
          Number(timesheet.adjustmentHours) > 0
        ) {
          totalHours = Number(totalHours) + Number(timesheet.adjustmentHours);
        } else {
          totalHours = Number(totalHours) + Number(timesheet.hours);
        }
      });
      timesheetPeriod.outSicks.map((outSick) => {
        totalHours = Number(totalHours) + Number(outSick.hours);
      });
      return Number(totalHours).toFixed(2);
    }
  };
  const handleSaveChange = (
    index,
    periodIndex,
    fileType = '',
    timesheetFinalized?: boolean,
  ) => {
    // if (checkValidation(rows[index])) {
    const bodyObject = setBodyFormData(
      cloneDeep(rows[index]),
      cloneDeep(rows[index]?.timesheetPeriods[periodIndex]),
      fileType,
      timesheetFinalized,
    );
    setFileUploadLoading(true);
    setLoader(true);
    addNewData(bodyObject, TIMESHEET.TimeSheets, {}, true)
      .then(() => {
        setTimeout(
          () => getTimesheetList(currentExpandId, expand, [], true),
          3000,
        );
        handleClose1();
        handleClose();
        setFileUploadLoading(false);
        setLoader(false);
      })
      .catch(() => {
        getTimesheetList(currentExpandId, expand, [], true);
        handleClose1();
        handleClose();
        setFileUploadLoading(false);
        setLoader(false);
      });
  };
  const submitaddNotes = (data) => {
    setNotesLoading(true);
    const bodyObject: any = {
      note: data.note,
      // timesheetId:
      //   rows[selectedRowIndex].timesheetPeriods[selectedTimesheetPeriodIndex]
      //     .timesheets[0].id,
      // timesheetPeriodId:
      //   rows[selectedRowIndex].timesheetPeriods[selectedTimesheetPeriodIndex]
      //     .id,
      // userId: rows[selectedRowIndex].userId,
    };
    if (
      rows[selectedRowIndex].timesheetPeriods[selectedTimesheetPeriodIndex]
        .notes &&
      rows[selectedRowIndex].timesheetPeriods[selectedTimesheetPeriodIndex]
        .notes[0].id
    ) {
      updateData(
        String(
          rows[selectedRowIndex].timesheetPeriods[selectedTimesheetPeriodIndex]
            .notes[0].id,
        ),
        bodyObject,
        TIMESHEET.TimeSheetNotesCreate,
        true,
      )
        .then(() => {
          getTimesheetList(currentExpandId, expand, [], true);
          handleCloseAddWeekNotes();
          reset();
          setNotesLoading(false);
        })
        .catch(() => {
          getTimesheetList(currentExpandId, expand, [], true);
          handleCloseAddWeekNotes();
          reset();
          setNotesLoading(false);
        });
    } else {
      bodyObject.timesheetPeriodId =
        rows[selectedRowIndex].timesheetPeriods[
          selectedTimesheetPeriodIndex
        ].id;
      bodyObject.userId = rows[selectedRowIndex].userId;
      addNewData(bodyObject, TIMESHEET.TimeSheetNotesCreate, {}, true)
        .then(() => {
          getTimesheetList(currentExpandId, expand, [], true);
          handleCloseAddWeekNotes();
          reset();
          setNotesLoading(false);
        })
        .catch(() => {
          getTimesheetList(currentExpandId, expand, [], true);
          handleCloseAddWeekNotes();
          reset();
          setNotesLoading(false);
        });
    }
    // rows[selectedRowIndex].timesheetPeriods.notes = [bodyObject];
    // setRows([...rows]);
  };
  const handleChangeInput = (
    e,
    timesheetsIndex,
    timesheetPeriodIndex,
    timesheetPeriod,
    index,
    type = 'timesheets',
  ) => {
    const { value } = e.target;
    const tempValue = value.replace(/[^\d.]/g, '');
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if (!tempValue.match(rgx)) {
      return false;
    }
    // Allow Only the Two digit
    const checkTwoDigit = tempValue.split('.');
    if (checkTwoDigit[1] && checkTwoDigit[1].length > 2) {
      return false;
    }
    if (type === 'timesheets') {
      timesheetPeriod[timesheetPeriodIndex].timesheets[timesheetsIndex].hours =
        tempValue ? tempValue : null;
      // timesheetPeriod[index].timesheets[timesheetsIndex].errors = {};
      // if (value === '') {
      //   timesheetPeriod[index].timesheets[timesheetsIndex].errors.message =
      //     'Hours is required';
      // }
    } else {
      timesheetPeriod[timesheetPeriodIndex].outSicks[timesheetsIndex].hours =
        tempValue ? tempValue : null;
      // timesheetPeriod[index].outSicks[timesheetsIndex].errors = {};
      // if (value === '') {
      //   timesheetPeriod[index].outSicks[timesheetsIndex].errors.message =
      //     'Hours is required';
      // }
    }
    rows[index].timesheetPeriods = timesheetPeriod;
    setRows([...rows]);
  };

  const [loader, setLoader] = React.useState<boolean>(false);
  const [loader1, setLoader1] = React.useState<boolean>(true);

  const getTimesheets = () => {
    if (loader1) {
      setLoader1(false);
      setLoader(true);
    }
    getAllListData(
      `${TIMESHEET.TimeSheets}/base?userId=${String(
        consultantId,
      )}&payPeriodYear=${selectedYear}`,
    )
      .then(async (response: any) => {
        if (response?.data) {
          response.data.map((row, index) => {
            //TODO: Sort by periodFrom is not working as expected
            response.data[index].timesheetPeriods = _.sortBy(
              row.timesheetPeriods,
              function (e) {
                return new Date(e?.periodFrom);
              },
              ['asc'],
            );
          });
          setExpand(0);
          setCurrentExpandId(response?.data[0]?.id);
          await getTimesheetList(response?.data[0]?.id, 0, response?.data);
        } else {
          setLoader(false);
        }
      })
      .catch(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (consultantId != undefined && consultantId != null) {
      getTimesheets();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consultantId, selectedYear]);

  // Generate array of years for dropdown
  const yearOptions = Array.from({ length: 3 }, (_, i) => moment().year() - i);

  const setBodyFormData = (
    row: any,
    periodRow,
    fileType = '',
    finalizedTimeSheet,
  ) => {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const tagUrl = `${window.location.origin}/admin/consultants/profile/${row?.userId}`;
    const postFormData = new FormData();
    let isParentTimesheetFinalized = true;
    postFormData.append('userId', row.userId);
    postFormData.append('tsPageURL', tagUrl);
    postFormData.append('timesheetFinalizedBy', userInfo?.id);
    postFormData.append('periodFrom', row.periodFrom);
    postFormData.append('periodTo', row.periodTo);
    postFormData.append('id', row.id);
    postFormData.append(
      'payPeriodId',
      row?.payPeriod ? row?.payPeriod?.id : '',
    );

    const setTimesheetPeriods = [];
    // row.timesheetPeriods.map((timesheetPeriod, index) => {
    const timesheetPeriodPushArray: any = {};
    timesheetPeriodPushArray.periodFrom = periodRow.periodFrom;
    timesheetPeriodPushArray.periodTo = periodRow.periodTo;
    timesheetPeriodPushArray.isTimesheetFinalized =
      finalizedTimeSheet && !_.isUndefined(finalizedTimeSheet)
        ? 'true'
        : periodRow?.isTimesheetFinalized
        ? String(periodRow.isTimesheetFinalized)
        : 'false';
    timesheetPeriodPushArray.timesheetFinalizedBy = userInfo?.id;
    if (periodRow?.id) {
      timesheetPeriodPushArray.id = periodRow.id;
    }

    // Filter out any outSicks entries that have been removed
    timesheetPeriodPushArray.timesheetOutSick = periodRow.outSicks.filter(
      (outSick) => outSick.hours && outSick.sickDate,
    );

    periodRow.timesheets.map((timesheet) => {
      delete timesheet['project'];
      timesheet['timesheetFiles'] = [];
      timesheet.hours = parseFloat(Number(timesheet.hours).toFixed(2));
      timesheet.adjustmentHours = parseFloat(
        Number(timesheet.adjustmentHours).toFixed(2),
      );
      timesheet.currentRate = parseFloat(
        Number(timesheet.currentRate).toFixed(2),
      );
      timesheet.adjustmentAmount = parseFloat(
        Number(timesheet.adjustmentAmount).toFixed(2),
      );
      timesheet.discount = parseFloat(Number(timesheet.discount).toFixed(2));
      timesheet.adjustmentRate = parseFloat(
        Number(timesheet.adjustmentRate).toFixed(2),
      );
      timesheet.adminFee = parseFloat(Number(timesheet.adminFee).toFixed(2));
    });
    timesheetPeriodPushArray.timesheets = periodRow.timesheets;
    setTimesheetPeriods.push(timesheetPeriodPushArray);
    // });

    row.timesheetPeriods.filter((timesheetPeriod: any) => {
      if (
        'isTimesheetFinalized' in timesheetPeriod &&
        timesheetPeriod.isTimesheetFinalized === false
      ) {
        isParentTimesheetFinalized = false;
        return;
      } else {
        isParentTimesheetFinalized = false;
        return;
      }
    });

    postFormData.append(
      'isTimesheetFinalized',
      String(isParentTimesheetFinalized),
    );

    if (row['files']) {
      row['files'].map((fileItem: any) => {
        const uniqueId = Math.floor(
          Math.random() * Math.floor(Math.random() * Date.now()),
        );
        if (!periodRow.timesheets[selectedTimesheetsIndex].timesheetFiles) {
          periodRow.timesheets[selectedTimesheetsIndex].timesheetFiles = [];
        }
        periodRow.timesheets[selectedTimesheetsIndex].timesheetFiles.push({
          fileType: fileType,
          fileUniqueId: uniqueId.toString(),
        });
        postFormData.append(`${uniqueId}`, fileItem);
      });
    }
    postFormData.append(
      'timesheetPeriods',
      JSON.stringify(setTimesheetPeriods),
    );
    return postFormData;
  };
  const addNewOutSick = (timesheetPeriod, timesheetPeriodIndex, index) => {
    timesheetPeriod[timesheetPeriodIndex].outSicks.push({
      hours: 0.0,
      sickDate: moment(timesheetPeriod[timesheetPeriodIndex].periodFrom).format(
        'YYYY-MM-DD',
      ),
    });
    rows[index].timesheetPeriods = timesheetPeriod;
    setRows([...rows]);
  };
  const onSubmit = (data) => {
    handleUploadDocument(data.fileType);
  };
  const handleCloseOpenViewDocument = () => {
    viewFileFetchGenRef.current += 1;
    revokeViewFileBlobUrl();
    setViewFileLoading(false);
    setTimeSheetViewSelected({});
    setOpenViewDocument(false);
  };

  const downloadTimesheetFile = (timesheetFile: any) => {
    void fetchAuthenticatedFileBlob(String(timesheetFile.id))
      .then((blob) => {
        const label =
          timesheetFile.timesheetFileType != null &&
          timesheetFile.timesheetFileType !== ''
            ? String(timesheetFile.timesheetFileType).replace(
                /[/\\?%*:|"<>]/g,
                '_',
              )
            : 'timesheet';
        saveAs(blob, `${label}.${String(timesheetFile.extension)}`);
      })
      .catch(() => {});
  };

  const handleUploadDocument = (fileType) => {
    handleSaveChange(selectedRowIndex, selectedTimesheetPeriodIndex, fileType);
  };
  const handleFinalizeTimesheet = () => {
    handleSaveChange(selectedRowIndex, selectedTimesheetPeriodIndex, '', true);
  };
  const saveTimesheet = (row: any, periodIndex: any) => {
    handleSaveChange(row, periodIndex);
  };

  const cosultantListDownload = async () => {
    const cYear = moment(timeSheetViewSelected.dateTo).format('YYYY');
    const cAt = timeSheetViewSelected.dateTo;
    const pathName = `${String(timeSheetViewSelected.lastName)}.${String(
      timeSheetViewSelected.firstName,
    )}.${String(
      timeSheetViewSelected.customerName
        ? timeSheetViewSelected.customerName
        : '',
    )}.${String(cYear)}.${String(moment(cAt).format('MM'))}.${String(
      moment(cAt).format('DD'),
    )}`;
    const downloadExtension = timeSheetViewSelected?.extension;
    const fileId = String(timeSheetViewSelected?.id);
    const blob = await fetchAuthenticatedFileBlob(fileId);
    if (downloadExtension === 'pdf') {
      saveAs(blob, `${pathName}.${String(downloadExtension)}`, {
        autoBom: true,
      });
    } else if (
      timeSheetViewSelected?.extension == 'jpg' ||
      timeSheetViewSelected?.extension == 'png' ||
      timeSheetViewSelected?.extension == 'jpeg' ||
      timeSheetViewSelected?.extension == 'svg'
    ) {
      const unit = 'pt';
      const size = 'A2';
      const orientation = 'portrait';
      const doc = new jsPDF(orientation, unit, size);
      const img = new Image();
      const objectUrl = URL.createObjectURL(blob);
      img.onload = () => {
        doc.addImage(img, timeSheetViewSelected?.extension, 250, 350, 700, 400);
        doc.save(`${pathName}.${String(downloadExtension)}`);
        URL.revokeObjectURL(objectUrl);
      };
      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
      };
      img.src = objectUrl;
    } else {
      saveAs(blob, `${pathName}.${String(downloadExtension)}`, {
        autoBom: true,
      });
    }
  };

  const showTimesheetAprrovedData = (
    index: number,
    timesheetPeriodIndex: number,
    timesheetPeriod: any,
    row: any,
    h: any,
  ) => {
    return (
      <>
        <Box
          sx={{
            borderRadius: 1,
            display: 'flex',
            justifyContent: 'space-between',
            m: 0,
            p: 0,
            pb: 1,
          }}>
          <Typography>
            {moment(timesheetPeriod?.periodFrom).format('MMM')}{' '}
            <strong>
              {moment(timesheetPeriod?.periodFrom).format('DD')} -{' '}
              {moment(timesheetPeriod?.periodTo).format('DD')}
            </strong>
          </Typography>
          <Typography component={'div'} display="flex" alignItems="center">
            <Typography
              sx={{
                paddingRight: isAdminScreen ? '5px' : '5px',
              }}>
              Total: <strong>{h}</strong>
            </Typography>
            {isAdminScreen && (
              <Typography
                component={'div'}
                className="finalize-approve"
                sx={{ paddingBottom: 'unset !important' }}>
                <Button
                  onClick={() => {
                    saveTimesheet(index, timesheetPeriodIndex);
                  }}
                  variant="contained">
                  Approve Timesheet
                </Button>
              </Typography>
            )}
          </Typography>
        </Box>
        <TableContainer component={'div'}>
          <Table sx={{ Width: '100%' }} aria-label="simple table">
            <TableHead
              sx={{
                backgroundColor: 'inherit !important',
              }}>
              <TableRow>
                <TableCell
                  sx={{
                    maxWidth: '200px !important',
                    width: '200px !important',
                  }}>
                  Project Worked On:
                </TableCell>
                <TableCell align="left">Paid:</TableCell>
                <TableCell align="left">Hours:</TableCell>
                <TableCell align="left">Adj. Hours:</TableCell>
                <TableCell
                  sx={{
                    maxWidth: '170px !important',
                    width: '170px !important',
                  }}>
                  Timesheet:
                </TableCell>
                <TableCell align="left">Current Rate:</TableCell>
                <TableCell align="left">Adj. Amount:</TableCell>
                <TableCell align="left">Discount:</TableCell>
                <TableCell align="left">Adj. Rate</TableCell>
                <TableCell align="left">Admin Fee:</TableCell>
                {showApproved && <TableCell align="left">Approved:</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {timesheetPeriod?.timesheets.map((timesheet, timesheetIndex) => {
                return (
                  <TableRow className="active-blue" key={timesheetIndex}>
                    <TableCell component="th" scope="row">
                      {timesheet?.project?.project}
                      <AssignmentDates
                        projectConsultant={timesheet?.projectConsultant}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {timesheet?.paid ? (
                        <img src={CheckGreen} />
                      ) : (
                        <img src={CheckRed} />
                      )}
                    </TableCell>
                    <TableCell align="left">
                      {isYearSplitPeriod(
                        timesheetPeriod?.periodFrom,
                        timesheetPeriod?.periodTo,
                      ) ? (
                        <Box
                          sx={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: '2px',
                          }}>
                          <span>{timesheet?.hours}</span>
                          <Tooltip
                            arrow
                            placement="top"
                            componentsProps={{
                              arrow: {
                                sx: {
                                  '&::before': {
                                    border: '0.5px solid #E5E7EB',
                                  },
                                  color: '#FFFFFF',
                                },
                              },
                              tooltip: {
                                sx: {
                                  backgroundColor: '#FFFFFF',
                                  border: '0.5px solid #E5E7EB',
                                  boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                                  color: '#111827',
                                  maxWidth: 'none',
                                  p: '10px 12px',
                                },
                              },
                            }}
                            title={(() => {
                              const ranges = getYearSplitRanges(
                                timesheetPeriod?.periodFrom,
                                timesheetPeriod?.periodTo,
                              );
                              const tys = timesheet?.timesheetYearSplits;
                              const hasAdjusted =
                                tys?.adjustedPriorYearHours != null ||
                                tys?.adjustedCurrentYearHours != null;
                              const hasOriginal =
                                tys &&
                                (parseFloat(tys.priorYearHours) > 0 ||
                                  parseFloat(tys.currentYearHours) > 0);
                              let aHrs: number;
                              let bHrs: number;
                              if (hasAdjusted) {
                                aHrs =
                                  parseFloat(tys.adjustedPriorYearHours) || 0;
                                bHrs =
                                  parseFloat(tys.adjustedCurrentYearHours) || 0;
                              } else if (hasOriginal) {
                                aHrs = parseFloat(tys.priorYearHours) || 0;
                                bHrs = parseFloat(tys.currentYearHours) || 0;
                              } else {
                                aHrs = parseFloat(timesheet?.hours) || 0;
                                bHrs = 0;
                              }
                              return (
                                <Box
                                  sx={{
                                    fontFamily: 'Red Hat Display Regular',
                                    minWidth: '180px',
                                    p: '4px',
                                  }}>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Red Hat Display Medium',
                                      fontSize: '12px',
                                      mb: '6px',
                                    }}>
                                    Hours by year
                                  </Typography>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      fontSize: '12px',
                                      justifyContent: 'space-between',
                                      mb: '3px',
                                    }}>
                                    <span>
                                      {ranges.first.year} (
                                      {ranges.first.shortLabel})
                                    </span>
                                    <span
                                      style={{
                                        fontFamily: 'Red Hat Display Medium',
                                        marginLeft: '12px',
                                      }}>
                                      {aHrs.toFixed(2)} hrs
                                    </span>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      fontSize: '12px',
                                      justifyContent: 'space-between',
                                      mb: '6px',
                                    }}>
                                    <span>
                                      {ranges.second.year} (
                                      {ranges.second.shortLabel})
                                    </span>
                                    <span
                                      style={{
                                        fontFamily: 'Red Hat Display Medium',
                                        marginLeft: '12px',
                                      }}>
                                      {bHrs.toFixed(2)} hrs
                                    </span>
                                  </Box>
                                  <Box
                                    sx={{
                                      borderTop: '0.5px solid #E5E7EB',
                                      display: 'flex',
                                      fontSize: '12px',
                                      justifyContent: 'space-between',
                                      pt: '6px',
                                    }}>
                                    <span
                                      style={{
                                        fontFamily: 'Red Hat Display Medium',
                                      }}>
                                      Week total
                                    </span>
                                    <span
                                      style={{
                                        fontFamily: 'Red Hat Display Bold',
                                        marginLeft: '12px',
                                      }}>
                                      {(aHrs + bHrs).toFixed(2)} hrs
                                    </span>
                                  </Box>
                                </Box>
                              );
                            })()}>
                            <InfoOutlinedIcon
                              sx={{
                                color: '#2563EB',
                                cursor: 'pointer',
                                fontSize: '18px',
                              }}
                            />
                          </Tooltip>
                        </Box>
                      ) : (
                        timesheet?.hours
                      )}
                    </TableCell>
                    <TableCell align="left">
                      {isAdminScreen ? (
                        <Button
                          variant="text"
                          onClick={() => {
                            handleEditOpen(
                              timesheet,
                              false,
                              row?.id,
                              timesheetPeriod?.id,
                              timesheetPeriod,
                            );
                          }}
                          sx={{
                            color: '#005ebf',
                            fontFamily: 'Red Hat Display Bold !important',
                            fontSize: '14px !important',
                            margin: '0px !important',
                            minWidth: '0px !important',
                            padding: '0px !important',
                            textDecoration: 'underline !important',
                            textTransform: 'capitalize',
                          }}>
                          {timesheet?.adjustmentHours !== '0.00'
                            ? parseFloat(timesheet?.adjustmentHours)
                            : 'Edit'}
                        </Button>
                      ) : (
                        timesheet?.adjustmentHours !== '0.00' &&
                        parseFloat(timesheet?.adjustmentHours)
                      )}
                    </TableCell>
                    <TableCell align="left">
                      {timesheet?.timesheetFiles?.map(
                        (timesheetFile, timesheetFileIndex) => (
                          <Typography
                            component={'a'}
                            sx={{
                              marginRight: '10px !important',
                              textDecoration: 'underline !important',
                            }}
                            className="pointer"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (
                                viewFormatSupportedArray.indexOf(
                                  timesheetFile.extension,
                                ) > -1
                              ) {
                                timesheetFile.customerName =
                                  timesheet?.project?.customerName;
                                timesheetFile.firstName = row?.user?.firstName;
                                timesheetFile.lastName = row?.user?.lastName;
                                timesheetFile.ultraStaffDbName =
                                  row?.user?.ultraStaffDbName;
                                timesheetFile.collectionFrequency =
                                  timesheet?.projectConsultant?.collectionFrequency;
                                timesheetFile.dateFrom =
                                  timesheetPeriod?.periodFrom;
                                timesheetFile.dateTo =
                                  timesheetPeriod?.periodTo;
                                handleOpenViewDocumentModel(timesheetFile);
                              } else {
                                downloadTimesheetFile(timesheetFile);
                              }
                            }}
                            key={timesheetFileIndex}>
                            {timesheetFile?.timesheetFileType &&
                              capitalizeText(timesheetFile?.timesheetFileType)}
                            {timesheetFileIndex !=
                              timesheet?.timesheetFiles.length - 1 && ','}
                          </Typography>
                        ),
                      )}
                      <Button
                        variant="text"
                        onClick={() => {
                          handleOpen1(
                            timesheetIndex,
                            timesheetPeriodIndex,
                            index,
                          );
                        }}
                        sx={{
                          color: 'red',
                          fontFamily: 'Red Hat Display Bold !important',
                          fontSize: '14px !important',
                          margin: '0px !important',
                          minWidth: '0px !important',
                          padding: '0px !important',
                          textDecoration: 'underline !important',
                          textTransform: 'capitalize',
                        }}>
                        Upload
                      </Button>
                    </TableCell>
                    <TableCell align="left">
                      {roundOfData(timesheet?.currentRate)}
                    </TableCell>
                    <TableCell align="left">
                      {roundOfData(timesheet?.adjustmentAmount)}
                    </TableCell>
                    <TableCell align="left">
                      {roundOfData(timesheet?.discount)}
                    </TableCell>
                    <TableCell align="left">
                      {roundOfData(timesheet?.adjustmentRate)}
                    </TableCell>
                    <TableCell align="left">
                      {roundOfData(timesheet?.adminFee)}
                    </TableCell>
                    {showApproved && (
                      <TableCell align="left">
                        <Checkbox
                          {...label}
                          disabled={!timesheetPeriod?.isTimesheetFinalized}
                          checked={timesheet?.approved}
                          onChange={(e) => {
                            timesheet.approved = e.target.checked;
                            timesheet.approvedBy = userInfo?.id;
                            rows[index].timesheetPeriods[
                              timesheetPeriodIndex
                            ].timesheets[timesheetIndex] = timesheet;
                            setRows([...rows]);
                          }}
                          sx={{
                            '& .Mui-checked MuiCheckbox-root': {
                              padding: '0px !important',
                            },
                            '&.Mui-checked': {
                              color: '#1D9900',
                            },
                            color: '#c9c6c6',
                          }}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
              {timesheetPeriod?.outSicks.map((outSick, outSickIndex) => {
                return (
                  <TableRow className="active-yellow" key={outSickIndex}>
                    <TableCell component="th" scope="row">
                      Out Sick
                    </TableCell>
                    <TableCell align="center">
                      <CustomInput
                        placeHolder=""
                        value={outSick.hours}
                        name={'outSick-hours'}
                        type={'text'}
                        onChange={(e: any) => {
                          handleChangeInput(
                            e,
                            outSickIndex,
                            timesheetPeriodIndex,
                            row.timesheetPeriods,
                            index,
                            'outSicks',
                          );
                        }}
                        error={outSick.errors?.message}
                        disabled={row?.isTimesheetFinalized}
                        inputProps={{
                          inputProps: {
                            min: 0,
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell align="left">
                      <DatePicker
                        placeHolder="Select Date"
                        value={
                          outSick.sickDate
                            ? outSick.sickDate.split('T')[0]
                            : null
                        }
                        onChange={(e: any) => {
                          outSick.sickDate = moment(new Date(e)).format(
                            'YYYY-MM-DD',
                          );
                          rows[index].timesheetPeriods[
                            timesheetPeriodIndex
                          ].outSicks[outSickIndex] = outSick;
                          setRows([...rows]);
                        }}
                        minDate={moment(timesheetPeriod.periodFrom).toDate()}
                        maxDate={moment(timesheetPeriod.periodTo).toDate()}
                        disabled={row?.isTimesheetFinalized}
                      />
                    </TableCell>
                    <TableCell align="left" />
                    {showApproved && <TableCell align="left" />}
                    <TableCell align="right">
                      <Typography
                        component={'a'}
                        className="pointer"
                        onClick={() =>
                          handleRemoveOutSick(
                            outSickIndex,
                            timesheetPeriodIndex,
                            row.timesheetPeriods,
                            index,
                          )
                        }>
                        <img src={CloseCircleIcon} />
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })}
              {row?.timesheetPeriods[timesheetPeriodIndex]?.notes[0]?.id &&
                timesheetPeriod?.notes.map((note, noteIndex) => (
                  <TableRow key={noteIndex}>
                    <TableCell
                      component="th"
                      colSpan={11}
                      scope="row"
                      sx={{ padding: '5px 0px' }}>
                      <Typography component={'div'} className="notices-details">
                        <Typography>{note.note}</Typography>
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  };
  return (
    <LoadingOverlay active={loader} spinner text="loading...">
      <Typography component="div" className="container-block Adjustment">
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, mr: 2 }}>
          <FormControl>
            <Select
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
              size="small"
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#E0E0E0',
                  borderRadius: '8px',
                },
                '& .MuiSelect-select': {
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  color: '#241A2E',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  padding: '8px 14px',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#DB2426',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#DB2426',
                },
                minWidth: '150px',
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    '& .MuiMenuItem-root': {
                      '&.Mui-selected': {
                        '&:hover': {
                          backgroundColor: 'rgba(219, 36, 38, 0.16)',
                        },
                        backgroundColor: 'rgba(219, 36, 38, 0.12)',
                      },
                      '&:hover': {
                        backgroundColor: 'rgba(219, 36, 38, 0.08)',
                      },
                      color: '#241A2E',
                      fontFamily: 'Red Hat Display Medium',
                      fontSize: '14px',
                      padding: '8px 14px',
                    },
                    borderRadius: '8px',
                    marginTop: '4px',
                  },
                },
              }}>
              {yearOptions.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
            {isAdminScreen ? (
              <Typography
                className="model-btn"
                component={'div'}
                sx={{ marginTop: '20px' }}>
                <Button
                  onClick={handleOpenGenerateTimesheet}
                  variant="outlined"
                  sx={{ textTransform: 'capitalize !important' }}>
                  Add New Timesheet
                </Button>
              </Typography>
            ) : null}
          </FormControl>
        </Box>
        {/* Add Line Item Pop-up */}
        <Modal
          open={openGenerateTimesheet}
          onClose={handleCloseGenerateTimesheet}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box sx={style1} className="model-widget">
            <Typography component="h2"> Add New Timesheet</Typography>

            <Typography
              component="div"
              sx={{ marginTop: '20px', paddingTop: '5px' }}>
              <Typography
                component="div"
                sx={{
                  color: '#292929',
                  fontFamily: 'Red Hat Display Regular !important',
                  fontSize: '12px',
                }}>
                Project
              </Typography>
              <Select
                style={{ marginTop: '5px', textTransform: 'capitalize' }}
                className="common-select"
                value={timeSheetProjectConsultantId}
                onChange={(e: any) => {
                  setTimeSheetProjectConsultantId(e?.target?.value);
                }}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}>
                <MenuItem value={''} style={{ textTransform: 'capitalize' }}>
                  Select
                </MenuItem>
                {projectsList.map((projectList: any) =>
                  projectList.projects.map(
                    (projectData: any, projectIndex: number) => (
                      <MenuItem
                        key={projectIndex}
                        value={projectData.projectConsultants[0].id}
                        style={{ textTransform: 'capitalize' }}>
                        {`${String(projectData.project)} (${String(
                          projectData.assignmentId,
                        )})`}
                      </MenuItem>
                    ),
                  ),
                )}
              </Select>
              <Typography
                component="div"
                sx={{
                  color: '#292929',
                  fontFamily: 'Red Hat Display Regular !important',
                  fontSize: '12px',
                  marginTop: '20px',
                }}>
                Pay Period
              </Typography>
              <Select
                style={{ marginTop: '5px', textTransform: 'capitalize' }}
                className="common-select"
                value={payPeriodId}
                onChange={(e: any) => {
                  setPayPeriodId(e?.target?.value);
                }}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}>
                <MenuItem value={''} style={{ textTransform: 'capitalize' }}>
                  Select
                </MenuItem>
                {payPeriods.map((row: any, index: number) => {
                  return (
                    <MenuItem
                      key={index}
                      value={row.id}
                      style={{ textTransform: 'capitalize' }}>
                      {`${String(
                        moment(row?.startDate).format('MM/DD/YYYY'),
                      )} - ${String(
                        moment(row?.endDate).format('MM/DD/YYYY'),
                      )}`}
                    </MenuItem>
                  );
                })}
              </Select>
            </Typography>
            <Typography
              className="model-btn"
              sx={{ marginTop: '20px' }}
              component={'div'}>
              <Button onClick={handleCloseGenerateTimesheet} variant="text">
                Cancel
              </Button>
              <Button variant="contained" onClick={handleSaveGenerateTimesheet}>
                Save changes
              </Button>
            </Typography>
          </Box>
        </Modal>
        <Typography sx={{ p: 2 }} component={'div'} className="common-accordin">
          {rows.length
            ? rows.map((row: any, index: number) => {
                let currentPeriod = moment(
                  moment().format('YYYY-MM-DD'),
                ).isBetween(
                  moment(row.periodFrom),
                  moment(row.periodTo),
                  undefined,
                  '[]',
                );
                const afterPeriod = moment(moment(row.periodFrom)).isAfter(
                  moment().format('YYYY-MM-DD'),
                );
                if (!row?.isTimesheetFinalized) {
                  currentPeriod = true;
                }
                if (currentPeriod || afterPeriod) {
                  return (
                    <TimesheetBox
                      className="timeline"
                      key={index}
                      expanded={expand === index}
                      pending={checkPaymentPending(row)}
                      onToggle={() => toggleAcordion(index, row?.id)}
                      totalLabel="Total Hours"
                      totalValue={getTotalHours(row)}
                      label={
                        <>
                          {moment(row?.periodFrom).format('MMMM')}{' '}
                          <strong>
                            {moment(row?.periodFrom).format('DD')} -{' '}
                            {moment(row?.periodTo).format('DD')}
                          </strong>
                        </>
                      }>
                      {expand === index && !loading2 ? (
                        row?.timesheetPeriods &&
                        row?.timesheetPeriods.map(
                          (timesheetPeriod, timesheetPeriodIndex) => {
                            let h = 0.0;
                            timesheetPeriod?.timesheets &&
                              timesheetPeriod?.timesheets.map((timesheet) => {
                                // Only use adjustment hours when they are greater than 0
                                if (
                                  timesheet.adjustmentHours &&
                                  parseFloat(timesheet.adjustmentHours) > 0
                                ) {
                                  h = h + parseFloat(timesheet.adjustmentHours);
                                } else {
                                  h = h + parseFloat(timesheet.hours);
                                }
                              });
                            timesheetPeriod?.outSicks &&
                              timesheetPeriod?.outSicks.map((outSick) => {
                                h = h + parseFloat(outSick.hours);
                              });
                            const isYearSplit = isYearSplitPeriod(
                              timesheetPeriod?.periodFrom,
                              timesheetPeriod?.periodTo,
                            );
                            return timesheetPeriod.isTimesheetFinalized ? (
                              <Typography
                                component={'div'}
                                className="timesheet-table"
                                sx={{
                                  borderLeft: isYearSplit
                                    ? '3px solid #B91C1C'
                                    : undefined,
                                  marginBottom: '15px !important',
                                  paddingLeft: isYearSplit ? '10px' : 0,
                                }}
                                key={timesheetPeriodIndex}>
                                {showTimesheetAprrovedData(
                                  index,
                                  timesheetPeriodIndex,
                                  timesheetPeriod,
                                  row,
                                  h,
                                )}
                              </Typography>
                            ) : (
                              <Typography
                                component={'div'}
                                className="status-details"
                                sx={{
                                  borderLeft: isYearSplit
                                    ? '3px solid #B91C1C'
                                    : undefined,
                                  paddingLeft: isYearSplit ? '10px' : 0,
                                }}
                                key={timesheetPeriodIndex}>
                                <Typography
                                  className={
                                    isAdminScreen
                                      ? 'timesheet-details timesheet-details-admin'
                                      : 'timesheet-details'
                                  }>
                                  <Typography
                                    component={'div'}
                                    className="finalize-approve">
                                    {isAdminScreen ? (
                                      <Typography
                                        component={'a'}
                                        className="pointer"
                                        onClick={() =>
                                          handleSaveChange(
                                            index,
                                            timesheetPeriodIndex,
                                          )
                                        }>
                                        Save Changes
                                      </Typography>
                                    ) : (
                                      <Typography
                                        component={'a'}
                                        className="pointer"
                                        onClick={() =>
                                          handleSaveChange(
                                            index,
                                            timesheetPeriodIndex,
                                          )
                                        }>
                                        Save Changes
                                      </Typography>
                                    )}
                                    {isAdminScreen ? (
                                      <Button
                                        onClick={() => {
                                          saveTimesheet(
                                            index,
                                            timesheetPeriodIndex,
                                          );
                                        }}
                                        variant="contained">
                                        Approve Timesheet
                                      </Button>
                                    ) : (
                                      <Button
                                        onClick={() => {
                                          handleOpen(
                                            index,
                                            timesheetPeriodIndex,
                                          );
                                        }}
                                        variant="contained">
                                        Finalize Timesheet
                                      </Button>
                                    )}
                                  </Typography>
                                  <Typography component={'div'}>
                                    <Box
                                      sx={{
                                        bgcolor: 'background.paper',
                                        borderRadius: 1,
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        m: 0,
                                        p: 0,
                                      }}>
                                      <Typography
                                        sx={{
                                          margin: '0 10px 0',
                                          width: '10%',
                                        }}>
                                        <em>
                                          {moment(
                                            timesheetPeriod?.periodFrom,
                                          ).format('MMM')}
                                        </em>{' '}
                                        {moment(
                                          timesheetPeriod?.periodFrom,
                                        ).format('DD')}{' '}
                                        -{' '}
                                        {isYearSplit && (
                                          <>
                                            {moment(
                                              timesheetPeriod?.periodTo,
                                            ).format('MMM')}{' '}
                                          </>
                                        )}
                                        {moment(
                                          timesheetPeriod?.periodTo,
                                        ).format('DD')}
                                      </Typography>
                                      <Typography sx={{ width: '90%' }}>
                                        <TableContainer component={'div'}>
                                          <Table
                                            sx={{ Width: '100%' }}
                                            aria-label="simple table">
                                            <TableHead
                                              sx={{
                                                backgroundColor:
                                                  'inherit !important',
                                              }}>
                                              <TableRow>
                                                <TableCell
                                                  sx={{ width: '35%' }}>
                                                  Project:
                                                </TableCell>
                                                <TableCell
                                                  sx={{ width: '15%' }}
                                                  align="center">
                                                  Hours:
                                                </TableCell>
                                                <TableCell
                                                  sx={{ width: '30%' }}
                                                  align="left">
                                                  Timesheet:
                                                </TableCell>
                                                {showApproved && (
                                                  <TableCell align="left">
                                                    Approved:
                                                  </TableCell>
                                                )}
                                                <TableCell
                                                  sx={{ width: '18%' }}
                                                  align="right"
                                                  className="hours-timesheet">
                                                  {showHours && (
                                                    <>
                                                      Hours:{' '}
                                                      <span>
                                                        {getTotalHoursSingleRow(
                                                          timesheetPeriod,
                                                        )}
                                                      </span>
                                                    </>
                                                  )}
                                                </TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              {timesheetPeriod?.timesheets &&
                                                timesheetPeriod?.timesheets.map(
                                                  (
                                                    timesheet,
                                                    timesheetIndex,
                                                  ) => (
                                                    <TableRow
                                                      className={
                                                        (!timesheet?.timesheetFiles ||
                                                          timesheet
                                                            ?.timesheetFiles
                                                            .length === 0) &&
                                                        parseInt(
                                                          timesheet.hours,
                                                        ) === 0
                                                          ? 'active-gray'
                                                          : timesheet.timesheetFiles
                                                          ? 'active-blue'
                                                          : 'active-yellow'
                                                      }
                                                      key={timesheetIndex}>
                                                      <TableCell
                                                        component="th"
                                                        scope="row">
                                                        {/* {timesheet.projectId} */}
                                                        <Stack
                                                          alignItems="center"
                                                          direction="row"
                                                          display="flex"
                                                          spacing={1}>
                                                          <Typography
                                                            sx={{
                                                              width: '70%',
                                                            }}
                                                            component={'p'}>
                                                            {
                                                              timesheet?.project
                                                                ?.project
                                                            }
                                                          </Typography>
                                                          {/* {timesheet.paid && ( */}
                                                          {showPaid &&
                                                            timesheet.paid && (
                                                              <Typography
                                                                alignItems="center"
                                                                display="flex"
                                                                justifyContent="flex-end"
                                                                sx={{
                                                                  width: '30%',
                                                                }}
                                                                component={'p'}>
                                                                <Chip
                                                                  className="chip-status-green"
                                                                  label={
                                                                    <Typography
                                                                      component={
                                                                        'div'
                                                                      }
                                                                      className="whiteText">
                                                                      <img
                                                                        src={
                                                                          DollarIcon
                                                                        }
                                                                        alt="Paid"
                                                                        width={
                                                                          20
                                                                        }
                                                                      />{' '}
                                                                      <span>
                                                                        Paid
                                                                      </span>
                                                                    </Typography>
                                                                  }
                                                                  color="success"
                                                                />
                                                              </Typography>
                                                            )}
                                                          {/* )} */}
                                                        </Stack>
                                                        <AssignmentDates
                                                          projectConsultant={
                                                            timesheet?.projectConsultant
                                                          }
                                                        />
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        {isYearSplit ? (
                                                          <Box
                                                            sx={{
                                                              alignItems:
                                                                'center',
                                                              display: 'flex',
                                                              gap: '2px',
                                                            }}>
                                                            <Box
                                                              sx={{
                                                                cursor:
                                                                  row?.isTimesheetFinalized
                                                                    ? 'default'
                                                                    : 'pointer',
                                                                flex: 1,
                                                                position:
                                                                  'relative',
                                                              }}
                                                              onClick={(e) => {
                                                                if (
                                                                  row?.isTimesheetFinalized
                                                                )
                                                                  return;
                                                                openHoursPopover(
                                                                  e,
                                                                  index,
                                                                  timesheetPeriodIndex,
                                                                  timesheetIndex,
                                                                  timesheetPeriod,
                                                                  timesheet,
                                                                );
                                                              }}>
                                                              <CustomInput
                                                                placeHolder=""
                                                                value={Number(
                                                                  timesheet.hours ||
                                                                    0,
                                                                ).toFixed(2)}
                                                                name={
                                                                  'time-sheet-hours'
                                                                }
                                                                type={'text'}
                                                                disabled={
                                                                  row?.isTimesheetFinalized
                                                                }
                                                                inputProps={{
                                                                  inputProps: {
                                                                    min: 0,
                                                                    style: {
                                                                      cursor:
                                                                        row?.isTimesheetFinalized
                                                                          ? 'default'
                                                                          : 'pointer',
                                                                    },
                                                                  },
                                                                  readOnly:
                                                                    true,
                                                                }}
                                                              />
                                                              <Box
                                                                sx={{
                                                                  bottom: 0,
                                                                  cursor:
                                                                    row?.isTimesheetFinalized
                                                                      ? 'default'
                                                                      : 'pointer',
                                                                  left: 0,
                                                                  position:
                                                                    'absolute',
                                                                  right: 0,
                                                                  top: 0,
                                                                }}
                                                              />
                                                            </Box>
                                                            <Tooltip
                                                              arrow
                                                              placement="top"
                                                              componentsProps={{
                                                                arrow: {
                                                                  sx: {
                                                                    '&::before':
                                                                      {
                                                                        border:
                                                                          '0.5px solid #E5E7EB',
                                                                      },
                                                                    color:
                                                                      '#FFFFFF',
                                                                  },
                                                                },
                                                                tooltip: {
                                                                  sx: {
                                                                    backgroundColor:
                                                                      '#FFFFFF',
                                                                    border:
                                                                      '0.5px solid #E5E7EB',
                                                                    boxShadow:
                                                                      '0 4px 16px rgba(0,0,0,0.08)',
                                                                    color:
                                                                      '#111827',
                                                                    maxWidth:
                                                                      'none',
                                                                    p: '10px 12px',
                                                                  },
                                                                },
                                                              }}
                                                              title={(() => {
                                                                const ranges =
                                                                  getYearSplitRanges(
                                                                    timesheetPeriod?.periodFrom,
                                                                    timesheetPeriod?.periodTo,
                                                                  );
                                                                const values =
                                                                  getSplitHoursValues(
                                                                    timesheetPeriod?.id,
                                                                    timesheet?.id,
                                                                    timesheet,
                                                                  );
                                                                const aHrs =
                                                                  parseFloat(
                                                                    values.a,
                                                                  ) || 0;
                                                                const bHrs =
                                                                  parseFloat(
                                                                    values.b,
                                                                  ) || 0;
                                                                return (
                                                                  <Box
                                                                    sx={{
                                                                      fontFamily:
                                                                        'Red Hat Display Regular',
                                                                      minWidth:
                                                                        '180px',
                                                                      p: '4px',
                                                                    }}>
                                                                    <Typography
                                                                      sx={{
                                                                        fontFamily:
                                                                          'Red Hat Display Medium',
                                                                        fontSize:
                                                                          '12px',
                                                                        mb: '6px',
                                                                      }}>
                                                                      Hours by
                                                                      year
                                                                    </Typography>
                                                                    <Box
                                                                      sx={{
                                                                        display:
                                                                          'flex',
                                                                        fontSize:
                                                                          '12px',
                                                                        justifyContent:
                                                                          'space-between',
                                                                        mb: '3px',
                                                                      }}>
                                                                      <span>
                                                                        {
                                                                          ranges
                                                                            .first
                                                                            .year
                                                                        }{' '}
                                                                        (
                                                                        {
                                                                          ranges
                                                                            .first
                                                                            .shortLabel
                                                                        }
                                                                        )
                                                                      </span>
                                                                      <span
                                                                        style={{
                                                                          fontFamily:
                                                                            'Red Hat Display Medium',
                                                                          marginLeft:
                                                                            '12px',
                                                                        }}>
                                                                        {aHrs.toFixed(
                                                                          2,
                                                                        )}{' '}
                                                                        hrs
                                                                      </span>
                                                                    </Box>
                                                                    <Box
                                                                      sx={{
                                                                        display:
                                                                          'flex',
                                                                        fontSize:
                                                                          '12px',
                                                                        justifyContent:
                                                                          'space-between',
                                                                        mb: '6px',
                                                                      }}>
                                                                      <span>
                                                                        {
                                                                          ranges
                                                                            .second
                                                                            .year
                                                                        }{' '}
                                                                        (
                                                                        {
                                                                          ranges
                                                                            .second
                                                                            .shortLabel
                                                                        }
                                                                        )
                                                                      </span>
                                                                      <span
                                                                        style={{
                                                                          fontFamily:
                                                                            'Red Hat Display Medium',
                                                                          marginLeft:
                                                                            '12px',
                                                                        }}>
                                                                        {bHrs.toFixed(
                                                                          2,
                                                                        )}{' '}
                                                                        hrs
                                                                      </span>
                                                                    </Box>
                                                                    <Box
                                                                      sx={{
                                                                        borderTop:
                                                                          '0.5px solid #E5E7EB',
                                                                        display:
                                                                          'flex',
                                                                        fontSize:
                                                                          '12px',
                                                                        justifyContent:
                                                                          'space-between',
                                                                        pt: '6px',
                                                                      }}>
                                                                      <span
                                                                        style={{
                                                                          fontFamily:
                                                                            'Red Hat Display Medium',
                                                                        }}>
                                                                        Week
                                                                        total
                                                                      </span>
                                                                      <span
                                                                        style={{
                                                                          fontFamily:
                                                                            'Red Hat Display Bold',
                                                                          marginLeft:
                                                                            '12px',
                                                                        }}>
                                                                        {(
                                                                          aHrs +
                                                                          bHrs
                                                                        ).toFixed(
                                                                          2,
                                                                        )}{' '}
                                                                        hrs
                                                                      </span>
                                                                    </Box>
                                                                  </Box>
                                                                );
                                                              })()}>
                                                              <InfoOutlinedIcon
                                                                sx={{
                                                                  color:
                                                                    '#2563EB',
                                                                  cursor:
                                                                    'pointer',
                                                                  fontSize:
                                                                    '18px',
                                                                }}
                                                              />
                                                            </Tooltip>
                                                          </Box>
                                                        ) : (
                                                          <CustomInput
                                                            placeHolder=""
                                                            value={
                                                              timesheet.hours
                                                            }
                                                            name={
                                                              'time-sheet-hours'
                                                            }
                                                            type={'text'}
                                                            disabled={
                                                              row?.isTimesheetFinalized
                                                            }
                                                            onChange={(
                                                              e: any,
                                                            ) => {
                                                              handleChangeInput(
                                                                e,
                                                                timesheetIndex,
                                                                timesheetPeriodIndex,
                                                                row.timesheetPeriods,
                                                                index,
                                                                'timesheets',
                                                              );
                                                            }}
                                                            error={
                                                              timesheet.errors
                                                                ?.message
                                                            }
                                                            inputProps={{
                                                              inputProps: {
                                                                min: 0,
                                                              },
                                                            }}
                                                          />
                                                        )}
                                                      </TableCell>
                                                      <TableCell align="left">
                                                        {timesheet?.timesheetFiles?.map(
                                                          (
                                                            timesheetFile,
                                                            timesheetFileIndex,
                                                          ) => (
                                                            <Typography
                                                              component={'a'}
                                                              className="pointer"
                                                              href="#"
                                                              onClick={(e) => {
                                                                e.preventDefault();
                                                                if (
                                                                  viewFormatSupportedArray.indexOf(
                                                                    timesheetFile.extension,
                                                                  ) > -1
                                                                ) {
                                                                  timesheetFile.customerName =
                                                                    timesheet?.project?.customerName;
                                                                  timesheetFile.firstName =
                                                                    row?.user?.firstName;
                                                                  timesheetFile.lastName =
                                                                    row?.user?.lastName;
                                                                  timesheetFile.ultraStaffDbName =
                                                                    row?.user?.ultraStaffDbName;
                                                                  timesheetFile.collectionFrequency =
                                                                    timesheet?.projectConsultant?.collectionFrequency;
                                                                  timesheetFile.dateFrom =
                                                                    timesheetPeriod?.periodFrom;
                                                                  timesheetFile.dateTo =
                                                                    timesheetPeriod?.periodTo;
                                                                  handleOpenViewDocumentModel(
                                                                    timesheetFile,
                                                                  );
                                                                } else {
                                                                  downloadTimesheetFile(
                                                                    timesheetFile,
                                                                  );
                                                                }
                                                              }}
                                                              key={
                                                                timesheetFileIndex
                                                              }>
                                                              {timesheetFile?.timesheetFileType &&
                                                                capitalizeText(
                                                                  timesheetFile?.timesheetFileType,
                                                                )}
                                                              {timesheetFileIndex !=
                                                                timesheet
                                                                  ?.timesheetFiles
                                                                  .length -
                                                                  1 && ','}
                                                            </Typography>
                                                          ),
                                                        )}
                                                      </TableCell>
                                                      {showApproved && (
                                                        <TableCell align="left">
                                                          <Checkbox
                                                            {...label}
                                                            disabled={
                                                              !timesheetPeriod?.isTimesheetFinalized
                                                            }
                                                            checked={
                                                              timesheet?.approved
                                                            }
                                                            onChange={(e) => {
                                                              timesheet.approved =
                                                                e.target.checked;
                                                              timesheet.approvedBy =
                                                                userInfo?.id;
                                                              rows[
                                                                index
                                                              ].timesheetPeriods[
                                                                timesheetPeriodIndex
                                                              ].timesheets[
                                                                timesheetIndex
                                                              ] = timesheet;
                                                              setRows([
                                                                ...rows,
                                                              ]);
                                                            }}
                                                            sx={{
                                                              '&.Mui-checked': {
                                                                color:
                                                                  '#1D9900',
                                                              },
                                                              color: '#c9c6c6',
                                                            }}
                                                          />
                                                        </TableCell>
                                                      )}
                                                      <TableCell align="right">
                                                        {!timesheet.approved &&
                                                          (!timesheet?.timesheetFiles ||
                                                            timesheet
                                                              ?.timesheetFiles
                                                              .length ===
                                                              0) && (
                                                            <img
                                                              src={UploadAlert}
                                                            />
                                                          )}
                                                        {/* {!row.isTimesheetFinalized && ( */}
                                                        {!timesheet.approved ? (
                                                          isAdminScreen ? (
                                                            <a
                                                              className="pointer"
                                                              onClick={() =>
                                                                handleOpen1(
                                                                  timesheetIndex,
                                                                  timesheetPeriodIndex,
                                                                  index,
                                                                )
                                                              }>
                                                              Upload
                                                            </a>
                                                          ) : (
                                                            <a
                                                              className="pointer"
                                                              onClick={() =>
                                                                handleOpen1(
                                                                  timesheetIndex,
                                                                  timesheetPeriodIndex,
                                                                  index,
                                                                )
                                                              }>
                                                              Upload
                                                            </a>
                                                          )
                                                        ) : (
                                                          <Typography />
                                                        )}
                                                        {/* )} */}
                                                      </TableCell>
                                                    </TableRow>
                                                  ),
                                                )}
                                              {timesheetPeriod?.outSicks &&
                                                timesheetPeriod?.outSicks.map(
                                                  (outSick, outSickIndex) => (
                                                    <TableRow
                                                      className="active-yellow"
                                                      key={outSickIndex}>
                                                      <TableCell
                                                        component="th"
                                                        scope="row">
                                                        Out Sick
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        <CustomInput
                                                          placeHolder=""
                                                          value={outSick.hours}
                                                          name={'outSick-hours'}
                                                          type={'text'}
                                                          onChange={(
                                                            e: any,
                                                          ) => {
                                                            handleChangeInput(
                                                              e,
                                                              outSickIndex,
                                                              timesheetPeriodIndex,
                                                              row.timesheetPeriods,
                                                              index,
                                                              'outSicks',
                                                            );
                                                          }}
                                                          error={
                                                            outSick.errors
                                                              ?.message
                                                          }
                                                          disabled={
                                                            row?.isTimesheetFinalized
                                                          }
                                                          inputProps={{
                                                            inputProps: {
                                                              min: 0,
                                                            },
                                                          }}
                                                        />
                                                      </TableCell>
                                                      <TableCell align="left">
                                                        <DatePicker
                                                          placeHolder="Select Date"
                                                          value={
                                                            outSick.sickDate
                                                              ? outSick.sickDate.split(
                                                                  'T',
                                                                )[0]
                                                              : null
                                                          }
                                                          onChange={(
                                                            e: any,
                                                          ) => {
                                                            outSick.sickDate =
                                                              moment(
                                                                new Date(e),
                                                              ).format(
                                                                'YYYY-MM-DD',
                                                              );
                                                            rows[
                                                              index
                                                            ].timesheetPeriods[
                                                              timesheetPeriodIndex
                                                            ].outSicks[
                                                              outSickIndex
                                                            ] = outSick;
                                                            setRows([...rows]);
                                                          }}
                                                          minDate={moment(
                                                            timesheetPeriod.periodFrom,
                                                          ).toDate()}
                                                          maxDate={moment(
                                                            timesheetPeriod.periodTo,
                                                          ).toDate()}
                                                          disabled={
                                                            row?.isTimesheetFinalized
                                                          }
                                                        />
                                                      </TableCell>
                                                      <TableCell align="left" />
                                                      {showApproved && (
                                                        <TableCell align="left" />
                                                      )}
                                                      <TableCell align="right">
                                                        <Typography
                                                          component={'a'}
                                                          className="pointer"
                                                          onClick={() =>
                                                            handleRemoveOutSick(
                                                              outSickIndex,
                                                              timesheetPeriodIndex,
                                                              row.timesheetPeriods,
                                                              index,
                                                            )
                                                          }>
                                                          <img
                                                            src={
                                                              CloseCircleIcon
                                                            }
                                                          />
                                                        </Typography>
                                                      </TableCell>
                                                    </TableRow>
                                                  ),
                                                )}
                                              {row?.timesheetPeriods[
                                                timesheetPeriodIndex
                                              ]?.notes[0]?.id &&
                                                timesheetPeriod?.notes.map(
                                                  (note, noteIndex) => (
                                                    <TableRow key={noteIndex}>
                                                      <TableCell
                                                        component="th"
                                                        colSpan={5}
                                                        scope="row"
                                                        sx={{
                                                          padding: '5px 0px',
                                                        }}>
                                                        <Typography
                                                          component={'div'}
                                                          className="notices-details">
                                                          <Grid item md={11}>
                                                            <Typography>
                                                              {note.note}
                                                            </Typography>
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            md={1}
                                                            alignContent="right">
                                                            <Typography
                                                              align="right"
                                                              className="pointer"
                                                              onClick={() =>
                                                                handleOpenAddWeekNotes(
                                                                  timesheetPeriodIndex,
                                                                  index,
                                                                )
                                                              }>
                                                              Edit
                                                            </Typography>
                                                          </Grid>
                                                        </Typography>
                                                      </TableCell>
                                                    </TableRow>
                                                  ),
                                                )}
                                            </TableBody>
                                          </Table>
                                        </TableContainer>
                                        {/* {!row.isTimesheetFinalized && ( */}
                                        <Typography
                                          component={'div'}
                                          className="notices">
                                          <Typography
                                            component={'a'}
                                            className="pointer"
                                            onClick={() =>
                                              addNewOutSick(
                                                row.timesheetPeriods,
                                                timesheetPeriodIndex,
                                                index,
                                              )
                                            }>
                                            Were you out sick this week?
                                          </Typography>
                                          {!row?.timesheetPeriods[
                                            timesheetPeriodIndex
                                          ]?.notes[0]?.id && (
                                            <Typography>
                                              <a
                                                className="pointer"
                                                onClick={() =>
                                                  handleOpenAddWeekNotes(
                                                    timesheetPeriodIndex,
                                                    index,
                                                  )
                                                }>
                                                Add Week Notes
                                              </a>
                                            </Typography>
                                          )}
                                        </Typography>
                                        {/* )} */}
                                      </Typography>
                                    </Box>
                                  </Typography>
                                </Typography>
                              </Typography>
                            );
                          },
                        )
                      ) : (
                        <Typography
                          component={'div'}
                          sx={{
                            justifyContent: 'center',
                            paddingBottom: '15px',
                            paddingTop: '5px',
                            textAlign: 'center',
                          }}>
                          <CircularProgress sx={{ color: '#340000' }} />
                        </Typography>
                      )}
                    </TimesheetBox>
                  );
                } else {
                  return (
                    <TimesheetBox
                      key={index}
                      expanded={expand === index}
                      pending={checkPaymentPending(row)}
                      onToggle={() => toggleAcordion(index, row?.id)}
                      label={
                        <>
                          {moment(row?.periodFrom).format('MMMM')}{' '}
                          <strong>
                            {moment(row?.periodFrom).format('DD')} -{' '}
                            {moment(row?.periodTo).format('DD')}
                          </strong>
                        </>
                      }>
                      {row?.timesheetPeriods &&
                        row?.timesheetPeriods.map(
                          (timesheetPeriod, timesheetPeriodIndex) => {
                            let h = 0.0;
                            timesheetPeriod?.timesheets &&
                              timesheetPeriod?.timesheets.map((timesheet) => {
                                // Only use adjustment hours when they are greater than 0
                                if (
                                  timesheet.adjustmentHours &&
                                  parseFloat(timesheet.adjustmentHours) > 0
                                ) {
                                  h = h + parseFloat(timesheet.adjustmentHours);
                                } else {
                                  h = h + parseFloat(timesheet.hours);
                                }
                              });
                            timesheetPeriod?.outSicks &&
                              timesheetPeriod?.outSicks.map((outSick) => {
                                h = h + parseFloat(outSick.hours);
                              });
                            return (
                              <Typography
                                component={'div'}
                                className="timesheet-table"
                                key={timesheetPeriodIndex}>
                                {showTimesheetAprrovedData(
                                  index,
                                  timesheetPeriodIndex,
                                  timesheetPeriod,
                                  row,
                                  h,
                                )}
                              </Typography>
                            );
                          },
                        )}
                    </TimesheetBox>
                  );
                }
              })
            : !loader && (
                <Typography component={'p'}>No Timesheet Found</Typography>
              )}
        </Typography>
      </Typography>
      {/* <!------------------Confirm Timesheet Markup--------------> */}
      <Modal
        open={editopen.open}
        onClose={handleEditClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={editstyle} className="editmodal">
          <Typography className="title">EDIT PROJECT HOURS</Typography>
          <Grid container columnSpacing={1.5} className="c-bottom">
            <Grid item md={6}>
              <Typography className="p-text">Project</Typography>
            </Grid>
            <Grid item md={3}>
              <Typography className="p-text">Hours</Typography>
            </Grid>
            <Grid item md={3}>
              <Typography className="p-text">Adjust Hours</Typography>
            </Grid>
            {!editopen.fullVisible && (
              <Grid
                container
                columnSpacing={1.5}
                sx={{ paddingLeft: '10px !important' }}>
                <Grid item md={6}>
                  <Typography className="pro-name">
                    {editopen?.data?.project?.project}
                  </Typography>
                </Grid>
                <Grid item md={3}>
                  <Typography className="pro-name">
                    {editopen?.data?.hours}
                  </Typography>
                </Grid>
                <Grid item md={3}>
                  <Typography className="p-text">
                    <CustomInput
                      placeHolder=""
                      value={
                        isYearSplitPeriod(
                          editopen.periodFrom,
                          editopen.periodTo,
                        )
                          ? (
                              (parseFloat(splitAdjust.a) || 0) +
                              (parseFloat(splitAdjust.b) || 0)
                            ).toFixed(2)
                          : editopen?.data?.adjustmentHours
                      }
                      name={'time-sheet-hours'}
                      type={'text'}
                      disabled={isYearSplitPeriod(
                        editopen.periodFrom,
                        editopen.periodTo,
                      )}
                      onChange={(e: any) => {
                        editopen.data.adjustmentHours = e.target.value;
                        setEditOpen({
                          ...editopen,
                          data: editopen?.data,
                        });
                      }}
                      inputProps={{
                        inputProps: { min: 0 },
                      }}
                      extraInputStyle={{
                        backgroundColor: isYearSplitPeriod(
                          editopen.periodFrom,
                          editopen.periodTo,
                        )
                          ? '#F3F4F6 !important'
                          : 'white !important',
                        height: '34px !important',
                        textAlign: 'center !important',
                      }}
                    />
                  </Typography>
                </Grid>
                {isYearSplitPeriod(editopen.periodFrom, editopen.periodTo) &&
                  (() => {
                    const ranges = getYearSplitRanges(
                      editopen.periodFrom,
                      editopen.periodTo,
                    );
                    const originalA =
                      parseFloat(
                        editopen?.data?.timesheetYearSplits?.priorYearHours,
                      ) || 0;
                    const originalB =
                      parseFloat(
                        editopen?.data?.timesheetYearSplits?.currentYearHours,
                      ) || 0;
                    return (
                      <Grid item md={12}>
                        <Box
                          sx={{
                            border: '1px solid #E5E7EB',
                            borderRadius: '8px',
                            mb: 1,
                            mt: 1,
                            p: '12px 0',
                          }}>
                          <Typography
                            sx={{
                              fontFamily: 'Red Hat Display Bold',
                              fontSize: '14px',
                              px: 1,
                            }}>
                            Split hours by week
                          </Typography>
                          <Typography
                            sx={{
                              color: '#6B7280',
                              fontFamily: 'Red Hat Display Regular',
                              fontSize: '12px',
                              mb: 1,
                              px: 1,
                            }}>
                            Pay period spans{' '}
                            {moment(editopen.periodFrom).format('MMM DD, YYYY')}{' '}
                            – {moment(editopen.periodTo).format('MMM DD, YYYY')}
                          </Typography>
                          <Box sx={{ borderTop: '1px solid #E5E7EB', pt: 1 }}>
                            <Grid
                              container
                              columnSpacing={1.5}
                              alignItems="center"
                              sx={{ mb: 0.5, px: 1 }}>
                              <Grid item md={6}>
                                <Typography
                                  sx={{
                                    fontFamily: 'Red Hat Display Bold',
                                    fontSize: '14px',
                                  }}>
                                  {ranges.first.year} ({ranges.first.shortLabel}
                                  )
                                </Typography>
                              </Grid>
                              <Grid item md={3}>
                                <Typography
                                  className="pro-name"
                                  sx={{ fontSize: '13px !important' }}>
                                  {originalA.toFixed(2)}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                md={3}
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}>
                                <CustomInput
                                  placeHolder="0.00"
                                  value={splitAdjust.a}
                                  name={'split-adjust-a'}
                                  type={'text'}
                                  onChange={(e: any) => {
                                    const val = sanitizeHoursInput(
                                      e.target.value,
                                    );
                                    if (val !== null)
                                      setSplitAdjust((prev) => ({
                                        ...prev,
                                        a: val,
                                      }));
                                  }}
                                  inputProps={{ inputProps: { min: 0 } }}
                                  extraInputStyle={{
                                    backgroundColor: 'white !important',
                                    height: '34px !important',
                                    textAlign: 'center !important',
                                    width: '90px',
                                  }}
                                />
                              </Grid>
                            </Grid>
                            <Box sx={{ borderTop: '1px solid #F3F4F6' }} />
                            <Grid
                              container
                              columnSpacing={1.5}
                              alignItems="center"
                              sx={{ mt: 0.5, px: 1 }}>
                              <Grid item md={6}>
                                <Typography
                                  sx={{
                                    fontFamily: 'Red Hat Display Bold',
                                    fontSize: '14px',
                                  }}>
                                  {ranges.second.year} (
                                  {ranges.second.shortLabel})
                                </Typography>
                              </Grid>
                              <Grid item md={3}>
                                <Typography
                                  className="pro-name"
                                  sx={{ fontSize: '13px !important' }}>
                                  {originalB.toFixed(2)}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                md={3}
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}>
                                <CustomInput
                                  placeHolder="0.00"
                                  value={splitAdjust.b}
                                  name={'split-adjust-b'}
                                  type={'text'}
                                  onChange={(e: any) => {
                                    const val = sanitizeHoursInput(
                                      e.target.value,
                                    );
                                    if (val !== null)
                                      setSplitAdjust((prev) => ({
                                        ...prev,
                                        b: val,
                                      }));
                                  }}
                                  inputProps={{ inputProps: { min: 0 } }}
                                  extraInputStyle={{
                                    backgroundColor: 'white !important',
                                    height: '34px !important',
                                    textAlign: 'center !important',
                                    width: '90px',
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })()}
                <Grid item md={12}>
                  <Typography className={'notesTitle'} component="h2">
                    Notes
                  </Typography>
                </Grid>
                <Grid item md={12}>
                  <CustomInput
                    className="common-textarea"
                    id="outlined-multiline-static"
                    isTextArea={true}
                    minRows={3}
                    type={'text'}
                    placeHolder={'enter reason for change'}
                    value={editopen.data.hourAdjustNotes}
                    onChange={(e: any) => {
                      editopen.data.hourAdjustNotes = e.target.value;
                      setEditOpen({
                        ...editopen,
                        data: editopen?.data,
                      });
                    }}
                    extraStyle={{
                      width: '100%',
                    }}
                    extraInputBaseStyle={{
                      margin: '0px !important',
                      padding: '0px !important',
                    }}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
          {/* <Typography className="note">
            Note: Lorem Ipsum is simply dummy text of the printing and
            typesetting industry. Lorem Ipsum has been the industrys standard
            dummy text ever since the 1500s, when an unknown printer took a
            galley of type and scrambled it to make a type specimen book.
          </Typography> */}
          <Typography className="model-btn" component={'div'}>
            <Button variant="text" onClick={handleEditClose}>
              Cancel
            </Button>
            <Button variant="contained" onClick={submitAdjustHour}>
              Submit Changes
            </Button>
          </Typography>
        </Box>
      </Modal>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style} className="model-widget">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Confirm Timesheet
          </Typography>
          <Typography
            component="h4"
            id="modal-modal-description"
            sx={{ mt: 2 }}>
            Are you sure your <span>HOURS</span> are correct?
          </Typography>
          <Typography component="h6">
            You will not be able to edit once submitted
          </Typography>

          <Typography component={'div'} className="model-timesheet">
            <Box
              sx={{
                bgcolor: 'background.paper',
                borderRadius: 1,
                display: 'flex',
                justifyContent: 'space-between',
                mb: 1,
                p: 0,
              }}>
              <Typography component={'div'}>
                <Typography sx={{ pr: 5 }}>
                  {moment(
                    rows[selectedRowIndex]?.timesheetPeriods[
                      selectedTimesheetPeriodIndex
                    ]?.periodFrom,
                  ).format('MMMM')}{' '}
                  <strong />
                </Typography>
                <Typography>
                  <span>
                    Pay Period:{' '}
                    <strong>
                      {moment(
                        rows[selectedRowIndex]?.timesheetPeriods[
                          selectedTimesheetPeriodIndex
                        ]?.periodFrom,
                      ).format('DD')}
                    </strong>
                  </span>
                </Typography>
              </Typography>
              <Typography component={'div'}>
                <Typography style={{ color: '#DB2426' }}>
                  Total Hours:{' '}
                  {/* <strong>{getTotalHours(rows[selectedRowIndex])}</strong> */}
                  <strong>
                    {getTotalHoursSingleRow(
                      rows[selectedRowIndex]?.timesheetPeriods[
                        selectedTimesheetPeriodIndex
                      ],
                    )}
                  </strong>
                </Typography>
              </Typography>
            </Box>

            <Typography
              component={'div'}
              className="timesheet-table"
              sx={{
                borderBottom: 'unset',
              }}>
              <Box
                sx={{
                  borderRadius: 1,
                  display: 'flex',
                  justifyContent: 'space-between',
                  mb: 0,
                  p: 0,
                }}>
                <Typography style={{ fontSize: '14px' }}>
                  {moment(
                    rows[selectedRowIndex]?.timesheetPeriods[
                      selectedTimesheetPeriodIndex
                    ]?.periodFrom,
                  ).format('MMMM')}{' '}
                  <strong>
                    {moment(
                      rows[selectedRowIndex]?.timesheetPeriods[
                        selectedTimesheetPeriodIndex
                      ]?.periodFrom,
                    ).format('DD')}{' '}
                    -{' '}
                    {moment(
                      rows[selectedRowIndex]?.timesheetPeriods[
                        selectedTimesheetPeriodIndex
                      ]?.periodTo,
                    ).format('DD')}
                  </strong>
                </Typography>
                <Typography style={{ fontSize: '14px' }}>
                  Total:{' '}
                  <strong>
                    {getTotalHoursSingleRow(
                      rows[selectedRowIndex]?.timesheetPeriods[
                        selectedTimesheetPeriodIndex
                      ],
                    )}
                  </strong>
                </Typography>
              </Box>
              <TableContainer component={'div'}>
                <Table sx={{ maxWidth: 315 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Project Worked On:</TableCell>
                      <TableCell align="left">Hours:</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows[selectedRowIndex]?.timesheetPeriods[
                      selectedTimesheetPeriodIndex
                    ]?.timesheets.map((timesheet, timesheetIndex) => (
                      <TableRow className="active-blue" key={timesheetIndex}>
                        <TableCell component="th" scope="row">
                          {timesheet?.project?.project}
                        </TableCell>
                        <TableCell align="left">{timesheet.hours}</TableCell>
                      </TableRow>
                    ))}
                    {rows[selectedRowIndex]?.timesheetPeriods[
                      selectedTimesheetPeriodIndex
                    ]?.outSicks.map((outSick, outSickIndex) => (
                      <TableRow className="active-blue" key={outSickIndex}>
                        <TableCell component="th" scope="row">
                          Out Sick
                        </TableCell>
                        <TableCell align="left">{outSick.hours}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Typography>

            {/* {rows[selectedRowIndex]?.timesheetPeriods.map(
              (timesheetPeriod, timesheetPeriodIndex) => (
                <Typography
                  component={'div'}
                  className="timesheet-table"
                  key={timesheetPeriodIndex}>
                  <Box
                    sx={{
                      borderRadius: 1,
                      display: 'flex',
                      justifyContent: 'space-between',
                      mb: 0,
                      p: 0,
                    }}>
                    <Typography style={{ fontSize: '14px' }}>
                      {moment(timesheetPeriod?.periodFrom).format('MMMM')}{' '}
                      <strong>
                        {moment(timesheetPeriod?.periodFrom).format('DD')} -{' '}
                        {moment(timesheetPeriod?.periodTo).format('DD')}
                      </strong>
                    </Typography>
                    <Typography style={{ fontSize: '14px' }}>
                      Total:{' '}
                      <strong>{getTotalHoursSingleRow(timesheetPeriod)}</strong>
                    </Typography>
                  </Box>
                  <TableContainer component={'div'}>
                    <Table sx={{ maxWidth: 315 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Project Worked On:</TableCell>
                          <TableCell align="left">Hours:</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {timesheetPeriod?.timesheets.map(
                          (timesheet, timesheetIndex) => (
                            <TableRow
                              className="active-blue"
                              key={timesheetIndex}>
                              <TableCell component="th" scope="row">
                                {timesheet?.project?.project}
                              </TableCell>
                              <TableCell align="left">
                                {timesheet.hours}
                              </TableCell>
                            </TableRow>
                          ),
                        )}
                        {timesheetPeriod?.outSicks.map(
                          (outSick, outSickIndex) => (
                            <TableRow
                              className="active-blue"
                              key={outSickIndex}>
                              <TableCell component="th" scope="row">
                                Out Sick
                              </TableCell>
                              <TableCell align="left">
                                {outSick.hours}
                              </TableCell>
                            </TableRow>
                          ),
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Typography>
              ),
            )} */}
          </Typography>

          <Typography className="model-btn" component={'div'}>
            <Button variant="text" onClick={handleClose}>
              NO, Cancel
            </Button>
            <Button variant="contained" onClick={handleFinalizeTimesheet}>
              Yes, Finalize Timesheet
            </Button>
          </Typography>
        </Box>
      </Modal>
      {/* <!-------------------------------Upload documents---------------------> */}
      <Modal
        open={open1}
        onClose={handleClose1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style1} className="model-widget">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Upload Document
            </Typography>
            <Typography>
              <label>File</label>
              <Typography>
                <Button
                  variant="contained"
                  component="label"
                  style={{
                    color: '#fff',
                    fontFamily: 'Red Hat Display SemiBold',
                  }}>
                  Upload
                  <input
                    hidden
                    // accept="image/*"
                    // multiple
                    type="file"
                    onChange={(e) => {
                      if (e.target.files[0]) {
                        rows[selectedRowIndex].files = [];
                        // if (!rows[selectedRowIndex].files) {
                        //   rows[selectedRowIndex].files = [];
                        // }
                        rows[selectedRowIndex].files.push(e.target.files[0]);
                        setRows([...rows]);
                      }
                      // rows[selectedRowIndex].timesheetPeriods[
                      //   selectedTimesheetPeriodIndex
                      // ].timesheets[
                      //   selectedTimesheetsIndex
                      // ].uniqueId = e.target.files[0];
                    }}
                  />
                </Button>
                {rows[selectedRowIndex]?.files?.map((imageName, index) => {
                  return (
                    <Typography
                      className="upload-btn"
                      style={{ paddingTop: 8 }}
                      key={index}>
                      <label>{imageName.name}</label>
                      <Typography
                        component={'a'}
                        className="pointer"
                        align="right"
                        onClick={() => {
                          rows[selectedRowIndex].files.splice(index, 1);
                          setRows([...rows]);
                        }}>
                        <img src={CloseCircleIcon} />
                      </Typography>
                    </Typography>
                  );
                })}
              </Typography>
            </Typography>
            <Typography>
              <label>Select File Type</label>
              <CustomSelect
                labelKey={'label'}
                valueKey={'value'}
                options={[
                  {
                    label: 'Timesheet',
                    value: 'Timesheet',
                  },
                  {
                    label: 'Approval',
                    value: 'Approval',
                  },
                  {
                    label: 'Approved Timesheet',
                    value: 'Approved Timesheet',
                  },
                ]}
                name={'fileType'}
                // value={''}
                placeHolder={'Select'}
                className={'common-select'}
                error={errors.fileType?.message}
                {...register('fileType', {
                  required: 'File type is required',
                })}
              />
              {/* <Select
                  className="common-select"
                  value={age}
                  onChange={handleChange}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  {...register("fileType", { required: true })}>
                  <MenuItem value="" />
                  <MenuItem value={'Timesheet'}>Timesheet</MenuItem>
                  <MenuItem value={'Approval'}>Approval</MenuItem>
                  <MenuItem value={'Approved Timesheet'}>
                    Approved Timesheet
                  </MenuItem>
                </Select> */}
            </Typography>
            <Typography
              className="notes"
              component={'div'}
              sx={{
                marginBottom: '0px !important',
              }}
            />
            <Typography className="model-btn" component={'div'}>
              <Button variant="text" onClick={handleClose1}>
                Cancel
              </Button>
              {rows[selectedRowIndex]?.files?.length ? (
                <CustomButton
                  variant="contained"
                  type="submit"
                  name={'Upload Document'}
                  loading={fileUploadLoading}
                  extraStyle={{ textTransform: 'capitalize' }}
                />
              ) : (
                <Button variant="contained" disabled>
                  Upload Document
                </Button>
              )}
            </Typography>
          </form>
        </Box>
      </Modal>
      {/* <!-------------------------------Add notes---------------------> */}
      <Modal
        open={openAddWeekNotes}
        onClose={handleCloseAddWeekNotes}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style2} className="model-widget">
          <form onSubmit={handleAddNotesSubmit(submitaddNotes)}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Add Notes
            </Typography>
            <Typography
              component="h4"
              id="modal-modal-description"
              style={{ marginTop: 0 }}>
              If you had less than 40 hours a week, why.
            </Typography>
            <Typography>
              <Controller
                control={control}
                defaultValue={
                  rows[selectedRowIndex]?.timesheetPeriods[
                    selectedTimesheetPeriodIndex
                  ]?.notes[0]?.note
                }
                name="note"
                render={({ field: { onChange, value, name, ref } }) => {
                  return (
                    <CustomInput
                      // sx={{ p: 0 }}
                      className="common-textarea"
                      id="outlined-multiline-static"
                      isTextArea={true}
                      minRows={3}
                      type={'text'}
                      name={name}
                      placeHolder={'Add Notes'}
                      value={value}
                      ref={ref}
                      onChange={(e: any) => {
                        onChange(e);
                      }}
                      // error={formState.errors?.note?.message}
                    />
                  );
                }}
              />
              {formState.errors?.note?.message && (
                <Typography className="errorText">
                  {formState.errors?.note?.message}
                </Typography>
              )}
            </Typography>
            <Typography className="model-btn" component={'div'}>
              <Button variant="text" onClick={handleCloseAddWeekNotes}>
                Cancel
              </Button>
              <CustomButton
                variant="contained"
                type="submit"
                name={'Submit'}
                loading={notesLoading}
                extraStyle={{ textTransform: 'capitalize' }}
              />
            </Typography>
          </form>
        </Box>
      </Modal>
      {/* <!-------------------------------View Timesheet Files---------------------> */}
      <Modal
        open={openViewDocument}
        onClose={handleCloseOpenViewDocument}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ overflow: 'scroll' }}>
        <Box sx={styleView} className="model-widget">
          <Grid container justifyContent="flex-end">
            {/* <IconButton
                aria-label="close"
                onClick={handleCloseOpenViewDocument}>
                <span>Close</span>
              </IconButton> */}
          </Grid>
          <Grid
            container
            sx={{
              alignItems: 'center',
              display: 'flex',
              // justifyContent: 'space-between',
            }}>
            <Grid container sm={8}>
              <Typography component="h2">
                {' '}
                {capitalizeText(timeSheetViewSelected?.timesheetFileType)}{' '}
              </Typography>
            </Grid>
            <Grid
              container
              sm={4}
              sx={{
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}>
              <IconButton
                aria-label="download"
                sx={{
                  border: '1px solid #E0E0E0 !important',
                  borderRadius: '10px !important',
                }}
                onClick={() => cosultantListDownload()}>
                <DownloadForOfflineIcon style={{ color: '#241A2E' }} />
              </IconButton>
              &nbsp;&nbsp;&nbsp;
              <IconButton
                aria-label="close"
                onClick={handleCloseOpenViewDocument}>
                <span>Close</span>
              </IconButton>
            </Grid>
          </Grid>
          {viewFileLoading && (
            <Typography
              component="div"
              sx={{
                justifyContent: 'center',
                paddingBottom: '15px',
                paddingTop: '24px',
                textAlign: 'center',
              }}>
              <CircularProgress sx={{ color: '#340000' }} />
            </Typography>
          )}
          {!viewFileLoading &&
            viewFileBlobUrl &&
            String(timeSheetViewSelected?.id) && (
              <FileViewer
                fileType={timeSheetViewSelected?.extension}
                filePath={viewFileBlobUrl}
                key={viewFileBlobUrl}
              />
            )}
        </Box>
      </Modal>
      <Popover
        open={Boolean(hoursPopover.anchor)}
        anchorEl={hoursPopover.anchor}
        onClose={closeHoursPopover}
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'center', vertical: 'top' }}
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
            fontFamily: 'Red Hat Display Regular',
            mt: '6px',
            padding: '14px',
            width: 300,
          },
        }}>
        {hoursPopover.ctx && (
          <Box>
            <Typography
              sx={{
                fontFamily: 'Red Hat Display Medium',
                fontSize: '13px',
                fontWeight: 'bold',
                mb: '4px',
              }}>
              Split hours by year
            </Typography>
            <Typography
              sx={{
                color: 'text.secondary',
                fontFamily: 'Red Hat Display Regular',
                fontSize: '13px',
                mb: '12px',
              }}>
              Week spans{' '}
              {moment(hoursPopover.ctx.timesheetPeriod?.periodFrom).format(
                'MMM DD, YYYY',
              )}{' '}
              –{' '}
              {moment(hoursPopover.ctx.timesheetPeriod?.periodTo).format(
                'MMM DD, YYYY',
              )}
            </Typography>
            {(() => {
              const ranges = hoursPopover.ctx.ranges;
              const selected = hoursPopover.draft.selected;
              const options: { label: string; value: 'a' | 'b' }[] = [
                {
                  label: `${String(ranges.first.year)} (${String(
                    ranges.first.shortLabel,
                  )})`,
                  value: 'a',
                },
                {
                  label: `${String(ranges.second.year)} (${String(
                    ranges.second.shortLabel,
                  )})`,
                  value: 'b',
                },
              ];
              return (
                <Box
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                    gap: '8px',
                    mb: '8px',
                  }}>
                  <Select
                    size="small"
                    value={selected}
                    onChange={(e) =>
                      updateHoursDraftSelected(e.target.value as 'a' | 'b')
                    }
                    sx={{
                      flex: 1,
                      fontFamily: 'Red Hat Display Bold',
                      fontSize: '15px',
                      height: 36,
                    }}>
                    {options.map((opt) => (
                      <MenuItem
                        key={opt.value}
                        value={opt.value}
                        sx={{
                          fontFamily: 'Red Hat Display Bold',
                          fontSize: '15px',
                        }}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <Box sx={{ width: 90 }}>
                    <CustomInput
                      placeHolder=""
                      value={hoursPopover.draft[selected]}
                      name={`popover-hours-${selected}`}
                      type={'text'}
                      onChange={(e: any) =>
                        updateHoursDraft(selected, e.target.value)
                      }
                      inputProps={{ inputProps: { min: 0 } }}
                    />
                  </Box>
                </Box>
              );
            })()}
            <Divider sx={{ my: '10px' }} />
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'space-between',
              }}>
              <Typography
                sx={{
                  color: 'text.secondary',
                  fontFamily: 'Red Hat Display Bold',
                  fontSize: '13px',
                }}>
                Week total
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                }}>
                {(
                  (parseFloat(hoursPopover.draft.a) || 0) +
                  (parseFloat(hoursPopover.draft.b) || 0)
                ).toFixed(2)}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'flex-end',
                mt: '12px',
              }}>
              <Button
                onClick={closeHoursPopover}
                variant="outlined"
                size="small"
                sx={{
                  color: 'inherit',
                  fontFamily: 'Red Hat Display Regular',
                  fontSize: '13px',
                  textTransform: 'none',
                }}>
                Cancel
              </Button>
              <Button
                onClick={applyHoursPopover}
                variant="contained"
                size="small"
                sx={{
                  '&:hover': { backgroundColor: '#991B1B' },
                  backgroundColor: '#B91C1C',
                  fontFamily: 'Red Hat Display Regular',
                  fontSize: '13px',
                  textTransform: 'none',
                }}>
                Apply
              </Button>
            </Box>
          </Box>
        )}
      </Popover>
    </LoadingOverlay>
  );
};
export default TimesheetComponent;
